import React, { useCallback, useContext, useEffect, useState, useRef } from 'react'
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import AdminTemplate from "../../components/admin/layouts/Template";
import Card from "../../components/common/Card";
import CardHeader from "../../components/common/CardHeader";
import CardBody from "../../components/common/CardBody";
import CardTitle from "../../components/common/AssessmentCardTitle";
import CardToolbar from "../../components/common/SelfGradeCardToolBar";
import TabList from "../../components/common/tabs/TabList";
import NavItem from "../../components/common/tabs/NavItem";
import moment from "moment";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Tooltip,
  Button,
  Modal,
  Box,
  Typography,
  Backdrop,
  CircularProgress,
  Autocomplete,
  Divider,
  Switch,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormGroup,
  Skeleton,
  Checkbox,
  Fab,
  Step,
  StepLabel,
  StepContent,
  Stepper,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Rating,
  TextField,
  Snackbar,
  Alert,
  List,
  ListItemAvatar,
  Avatar,
  AvatarGroup,
  Chip,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  LinearProgress,
  ChevronLef,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";

import MaterialCustomTablePagination from "../../components/common/MaterialCustomTablePagination.js";
import DataHandler from "../../handlers/DataHandler.js";
import { MainContext } from "../../context/main/main-context.js";
import "../question/QuestionsLibrary.css";
import { debounce } from 'lodash';
import {
  convertFromRaw,
  convertToRaw,
  EditorState,
  ContentState
} from "draft-js";
import CheckBox from "../../components/common/form/CheckBox.js";
import CheckBoxInline from "../../components/common/form/CheckBoxInline.js";
import RadioInline from '../../components/common/form/RadioInline.js';
import Radio from '../../components/common/form/Radio.js';
import { Editor } from "react-draft-wysiwyg";
import { questionMCQAnswerTypeConstants, questionTypeConstants } from "../../helper/constants.js";
import sweetAlert, { sweetApproveAlert, sweetConfirmAlert, sweetStatusAlert, sweetConfirmAlertWithChecklist } from '../../components/common/SweetAlert.js';
import FinishReviewModal from './FinishReviewModal.js';
import SimpleReactValidator from 'simple-react-validator';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import StarIcon from '@mui/icons-material/Star';
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ThreePTwoToneIcon from '@mui/icons-material/ThreePTwoTone';
import ThreePSharpIcon from '@mui/icons-material/ThreePSharp';
import { assessmentService } from "../../service/assessment/assessmentService.js";
import { ASSESSMENT_LIBRARY_FILTERS } from "../../helper/constants";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PaperListChips from "../manage/paper/edsider/FindPaperTabs/PaperListChips.js";
import ReactForm from "react-bootstrap/Form";
import { SelfImprovement, Groups } from "@mui/icons-material";
import ClearIcon from '@mui/icons-material/Clear';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import PersonIcon from '@mui/icons-material/Person';
import { manageUserService } from '../../service/user_management/manage.user.service.js';
import EditIcon from '@mui/icons-material/Edit';
import EditQuestionModal from './EditQuestionModal.js';
import { assessmentStatusService } from "../../service/settings/assessment/statusService.js";
import { assessmentStatusConstants } from "../../helper/constants.js";
import CustomEditor from "../../components/common/editor/ViewEditor.js";
import TimeZoneHandler from "../../handlers/TimeZoneHandler.js";
import AssessmentInfoCard from "./components/AssessmentInfoCard.js";
import { useLocation } from "react-router-dom";
import { history } from "../../helper/history.js";
import PaperFilterLayout from "../manage/paper/edsider/TheFilter/PaperFilterLayout.js";
import { EMPLOYEE_FILTERS } from '../../helper/constants.js';
import StickyCardBody from '../../components/common/StickyCardBody.js';
import Form from "react-bootstrap/Form";
import { HiBattery100 } from 'react-icons/hi2';
import './AssessmentReview.css';

const paperFilterOptions = [
  {
    "label": "My Papers",
    "value": "my_papers"
  },
  {
    "label": "All Papers",
    "value": "all_papers"
  }
]

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 16,
  height: 16,
  boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: '#f5f8fa',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5',
    ...theme.applyStyles('dark', {
      backgroundColor: '#30404d',
    }),
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
    ...theme.applyStyles('dark', {
      background: 'rgba(57,75,89,.5)',
    }),
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
    backgroundColor: '#394b59',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',
  }),
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&::before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

function BpCheckbox(props) {
  return (
    <Checkbox
      sx={{ '&:hover': { bgcolor: 'transparent' } }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ 'aria-label': 'Checkbox demo' }}
      {...props}
    />
  );
}

const subCommentModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
};


function AssessmentReview() {

  const [validator] = useState(new SimpleReactValidator());
  const [questionRefs, setQuestionRefs] = useState([])
  const [assessmentDetails, setAssessmentDetails] = useState({})
  const [containerRef, setContainerRef] = useState(useRef(null))
  const [employeeType, setEmployeeType] = useState(sessionStorage.getItem("employeeType"));

  const statusDisplayMapping = {

    Initial: "Initial",
    Ready: "Ready",
    Review: "Review",
    Published: "Published",
    Retired: "Retired",
    InReview: "InReview",
    ReferBack: "Refer Back",
    ReviewCompleted: "Review Completed",

  };

  const {
    loading,
    comment_loading,
    myAssessments,
    totalCount,
    gradeCounts,
    subjectCounts,
    languageCounts,
    examCategoryCounts,
    sourceCounts,
    authorCounts,
    categoryCounts,
    difficultyCounts,
    chapterCounts,
    yearCounts,
    termCounts,
    statusCounts,
    createdByCounts,
    assesment_status_types,
    fetchAllMyAssessments,
    reviewerCount,

    assmnt_content,
    asmnt_details,
    assmnt_loading,
    fetchLoadAssesmentQuestionById,

    questionContents,
    getAllQuestionContents,

    assesment_review,
    assessment_operation,
    fetchAllReviewComments,
    fetchAllOperationComments,

    assesment_review_state,
    review_loading,
    addUpdateReviewForAssesment,

    finishPaperReview,
    setReview,
    finishPaperOperation,
    finish_assesment_review,

    finalizePaper,
    finalize_paper,

    addSubReviewForAssesment,
    addOperationCommentForAssessment,
    assesment_sub_review_state,
    sub_review_loading,

    assesment_mark_as_review_state,
    mark_as_review_loading,
    markAsReviewForQuestion,

    setLoadings,

    assignReviewer,
    assign_reviewer,

    assignOperator,
    assign_operator,

    changeAssignedReviewer,
    changeAssignedOperator,

    assignment_background_loading,

    finishPaperReviewByCompleted,

    setPaperToPublish,
    operation_comment_loading

  } = useContext(MainContext)

  const [state, setState] = useState({
    limit: 10,
    offset: 0,
    sort_column: 'created_at',
    sort_direction: 'DESC',
    search_term: '',
    search_input: '',
    selectedGrades: null,
    selectedChapters: null,
    selectedsubjects: null,
    selectedAuthors: null,
    selectedYears: null,
    selectedCategories: null,
    selectedTerms: null,
    selectedDifficulties: null,
    selectedLanguages: null,
    selectedStatuses: null,
    selectedExamCategories: null,
    selectedReviewers: null,
    selectedStartDate: null,
    selectedEndDate: null,
    isTableDataLoading: false,
    allCategories: [],
    allExamCategories: [],
    allLanguages: [],
    allSubjects: [],
    allAuthors: [],
    allYears: [],
    allDifficulties: [],
    allGrades: [],
    allTerms: [],
    allChapters: [],
    allStatuses: [],
    filterValues: [],
    allReviewers: [],
  });

  const [subQuestions, setSubQuestions] = useState([])
  const [subQuestionsIndexes, setSubQuestionsIndexes] = useState([])
  const [questions, setQuestions] = useState(null)
  const [questionContent, setQuestionContent] = useState(null)
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [paperSwitchOptions, setPaperSwitchOptions] = useState(paperFilterOptions[0]);

  const [isModalOpen, setIsModalOpen] = useState(false)

  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const [currentAssessmentId, setCurrentAssessmentId] = useState(null);
  const [currentAssessmentStatusId, setCurrentAssessmentStatusId] = useState(null);
  const [currentAssessment, setCurrentAssessment] = useState(null);
  const [comments, setComments] = useState([]);
  const [operationComments, setOperationComments] = useState([]);
  const [isChanged, setIsChanged] = useState(false)
  const [isFinishReviewModalOpen, setIsFinishReviewModalOpen] = useState(false);
  const [filteredStatusOptions, setFilteredStatusOptions] = useState(assesment_status_types || [])

  const [isAssigned, setIsAssigned] = useState(false)

  const [subCommentModal, setSubCommentModal] = useState(false)
  const [currentQIndex, setCurrentQIndex] = useState(null)
  const [currentquestionId, setCurrentquestionId] = useState(null)
  const [subComment, setSubComment] = useState('');
  const [markAsReview, setMarkAsReview] = useState([]);
  const [operationComplete, setOperationComplete] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: '',
  });
  const [loadingStates, setLoadingStates] = useState({});
  const [validateStates, setValidateStates] = useState({});

  const [reviewerModal, setReviewerModal] = useState(false);
  const [reviewersList, setReviewersList] = useState([])
  const [assessmentStatusesList, setAssessmentStatusesList] = useState([])
  const [selectedOperation, setSelectedOperation] = useState(null);
  const [selectedAssessmentOperationId, setselectedAssessmentOperationId] = useState(null);
  const [selectedReviewer, setSelectedReviewer] = useState(null);
  const [selectedAssessment, setSelectedAssessment] = useState({});
  const [add_review_loading, setAddReviewLoading] = useState(false)

  const [operationLoading, setOperationLoading] = useState(true);
  const [reviewerLoading, setReviewerLoading] = useState(true);
  const [openAssessmentStatusDialog, setOpenAssessmentStatusDialog] = useState(false);
  const [selectedAssessmentStatus, setSelectedAssessmentStatus] = useState("");

  const statusOptions = Object.values(assessmentStatusConstants).filter(
    (status) =>
      status.name === assessmentStatusConstants.REFERBACK.name ||
      status.name === assessmentStatusConstants.ReviewCompleted.name
  );

  const [selectedQuestion, setSelectedQuestion] = useState({
    isOpen: false,
    questionId: null,
    questionState: null,
    answerState: null, // For descriptive questions
    answerStates: null, // For MCQ questions
    guidanceState: null,
    subQuestions: null, // For subquestions
    type: null,
    answerTypeId: null,
    mcqAnswer: null
  });
  const [selectedQuestionId, setSelectedQuestionId] = useState(null)

  const [questionStates, setQuestionStates] = useState({});

  const [assessment_parts, set_assessment_parts] = useState([])
  const [assessment_sections, set_assessment_sections] = useState([])

  const location = useLocation();
  const selectedStatusFilterFromNav = location.state?.selectedStatusFilter;
  const [isAppliedStatusId, setIsAppliedStatusId] = useState(null);


  const handlefetchAllMyAssessments = useCallback(
    debounce(async () => {
      const {
        limit,
        offset,
        sort_column,
        sort_direction,
        search_term,
        selectedGrades,
        selectedChapters,
        selectedsubjects,
        selectedAuthors,
        selectedYears,
        selectedCategories,
        selectedTerms,
        selectedDifficulties,
        selectedLanguages,
        selectedStatuses,
        selectedExamCategories,
        selectedStartDate,
        selectedEndDate,
        selectedReviewers,
      } = state;


      const user_id = DataHandler.getFromSession('manage_user_id');
      const staff_user_id = DataHandler.getFromSession('user_id');
      const filterOptions = paperSwitchOptions?.value

      setState((prevState) => ({ ...prevState, isTableDataLoading: true }));

      try {

        if (history?.location?.state?.value && !isAppliedStatusId) {
          const selectedStatusFilterFromNav = history.location.state;
          const statusId = selectedStatusFilterFromNav.value;

          if (statusId) {

            const statusIdFromNav = [statusId]

            if (statusIdFromNav && statusIdFromNav.length > 0) {

              setIsAppliedStatusId(true)
              await fetchAllMyAssessments(
                filterOptions,
                employeeType,
                user_id,
                staff_user_id,
                limit,
                offset,
                sort_column,
                sort_direction,
                search_term,
                selectedCategories,
                selectedAuthors,
                selectedChapters,
                selectedGrades,
                selectedDifficulties,
                selectedLanguages,
                selectedTerms,
                selectedYears,
                selectedsubjects,
                statusIdFromNav,
                selectedExamCategories,
                selectedStartDate,
                selectedEndDate,
                assign_reviewer,
                null,
                selectedReviewers
              );

            }
            else {
              await fetchAllMyAssessments(
                filterOptions,
                employeeType,
                user_id,
                staff_user_id,
                limit,
                offset,
                sort_column,
                sort_direction,
                search_term,
                selectedCategories,
                selectedAuthors,
                selectedChapters,
                selectedGrades,
                selectedDifficulties,
                selectedLanguages,
                selectedTerms,
                selectedYears,
                selectedsubjects,
                selectedStatuses,
                selectedExamCategories,
                selectedStartDate,
                selectedEndDate,
                assign_reviewer,
                null,
                selectedReviewers
              );
            }



          }


        }
        else {

          await fetchAllMyAssessments(
            filterOptions,
            employeeType,
            user_id,
            staff_user_id,
            limit,
            offset,
            sort_column,
            sort_direction,
            search_term,
            selectedCategories,
            selectedAuthors,
            selectedChapters,
            selectedGrades,
            selectedDifficulties,
            selectedLanguages,
            selectedTerms,
            selectedYears,
            selectedsubjects,
            selectedStatuses,
            selectedExamCategories,
            selectedStartDate,
            selectedEndDate,
            assign_reviewer,
            null,
            selectedReviewers
          );

        }


      } catch (error) {
        console.error('Error fetching assessments:', error);
      } finally {
        setState((prevState) => ({ ...prevState, isTableDataLoading: false }));
      }
    }, 300), // Debounce delay of 300ms
    [state, paperSwitchOptions, assign_reviewer]
  );

  const handleSearchInput = useCallback(
    debounce((value) => {
      const search_term = value.trim();
      //const regex = /^[\w\s\d@&.,:;!?()\-_/\\[\]{}'"|#*~+=%$^<>]*$/;
      const regex = /^[\p{L}\p{M}\p{N}\p{P}\p{S}\s]*$/u;

      // if (search_term !== "") {
      // 	setState((prevState) => ({ ...prevState, limit: totalCount }));
      // }

      if (search_term === "" || regex.test(search_term)) {
        setState((prevState) => ({
          ...prevState,
          // limit: search_term !== "" ? totalCount : rowsPerPage,
          // search_term,
          // isTableDataLoading: true,
          search_input: search_term,
          offset: 0,
          currentPage: 0,
          searchError: false,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          search_term,
          searchError: true
        }));
      }
    }, 300),
    //[state.search_term]
    []

  );
  useEffect(() => {

    handlefetchAllMyAssessments();
  }, []
  );
  const fetchAllAssessmentMetaData = async () => {
    setState((prevState) => ({ ...prevState, isTableDataLoading: true }));

    const fetchAssessmentMetaData =
      await assessmentService.getAllAssessmentMetaData();

    const teacherRoles = ["TEACH", "MASAD"];

    const teacherResponse = await manageUserService.getTeachersforDropdown(teacherRoles);

    await Promise.all([fetchAssessmentMetaData, teacherResponse])
      .then(([assessmentMetaDataResponse, teacherResponseData]) => {


        // const [assessmentMetaDataResponse] = response;

        setState((prevState) => ({
          ...prevState,
          allCategories: assessmentMetaDataResponse.data.find((item) => "categories" in item).categories,
          allExamCategories: assessmentMetaDataResponse.data.find((item) => "exam_categories" in item).exam_categories,
          allLanguages: assessmentMetaDataResponse.data.find((item) => "languages" in item).languages,
          allSubjects: assessmentMetaDataResponse.data.find((item) => "subjects" in item).subjects,
          allAuthors: assessmentMetaDataResponse.data.find((item) => "authors" in item).authors,
          allYears: assessmentMetaDataResponse.data.find((item) => "years" in item).years,
          allDifficulties: assessmentMetaDataResponse.data.find((item) => "difficulty_types" in item).difficulty_types,
          allGrades: assessmentMetaDataResponse.data.find((item) => "grades" in item).grades,
          allTerms: assessmentMetaDataResponse.data.find((item) => "terms" in item).terms,
          allChapters: assessmentMetaDataResponse.data.find((item) => "chapters" in item).chapters,
          allStatuses: assessmentMetaDataResponse.data.find((item) => "statuses" in item).statuses,
          isTableDataLoading: false,
          allReviewers: teacherResponseData?.data
            ? teacherResponseData.data
            : [],
        }));
      })
      .catch((error) => {
        setState((prevState) => ({ ...prevState, isTableDataLoading: false }));
      });
  };


  const handleFilterChange = (newSelectedFilters) => {

    const getOrNull = (key) =>
      newSelectedFilters[key] && newSelectedFilters[key].length > 0
        ? newSelectedFilters[key]
        : null;

    setState((prev) => ({
      ...prev,

      search_term: prev.search_input,
      selectedGrades: getOrNull("Grade"),
      selectedsubjects: getOrNull("Subject"),
      selectedCategories: getOrNull("Category"),
      selectedAuthors: getOrNull("Author"),
      selectedChapters: getOrNull("Chapter"),
      selectedDifficulties: getOrNull("Difficulty"),
      selectedLanguages: getOrNull("Language"),
      selectedYears: getOrNull("Year"),
      selectedTerms: getOrNull("Term"),
      selectedStatuses: getOrNull("Status"),
      selectedReviewers: getOrNull("Reviewers"),
      selectedExamCategories: getOrNull("Exam_Category"),
      selectedStartDate: getOrNull("StartDate"),
      selectedEndDate: getOrNull("EndDate"),
      selectedYears: getOrNull("Year"),

      offset: 0,
      currentPage: 0,


    }));
  };


  const onSelectFilterMulti = (selectedItem) => {


    const { filterValues } = state;

    let updatedFilterValues = [...filterValues];

    const index = updatedFilterValues.findIndex(
      (item) =>
        item.filter === selectedItem.filter &&
        item[`${selectedItem.filter.toLowerCase()}_id`] === selectedItem[`${selectedItem.filter.toLowerCase()}_id`]
    );


    if (index === -1) {

      updatedFilterValues.push(selectedItem);

    } else {

      updatedFilterValues.splice(index, 1);
    }

    onSelectFilterMultiProcess(updatedFilterValues);
  };

  const onSelectFilterMultiProcess = (filterValues) => {

    const filterMap = {
      Category: [],
      Exam_Category: [],
      Difficulty: [],
      Language: [],
      Subject: [],
      Author: [],
      Year: [],
      Term: [],
      Chapter: [],
      Grade: [],
      Status: [],
      Reviewers: []
    };

    filterValues.forEach((val) => {
      const filterType = val.filter;
      if (filterType && filterMap.hasOwnProperty(filterType)) {
        switch (filterType) {
          case "Category":
            filterMap.Category.push(val?.category_id);
            break;
          case "Exam_Category":
            filterMap.Exam_Category.push(val?.exam_category_id);
            break;
          case "Difficulty":
            filterMap.Difficulty.push(val?.difficulty_id);
            break;
          case "Language":
            filterMap.Language.push(val?.language_id);
            break;
          case "Subject":
            filterMap.Subject.push(val?.subject_id);
            break;
          case "Author":
            filterMap.Author.push(val?.author_id);
            break;
          case "Year":
            filterMap.Year.push(val?.year_id);
            break;
          case "Term":
            filterMap.Term.push(val?.term_id);
            break;
          case "Chapter":
            filterMap.Chapter.push(val?.chapter_id);
            break;
          case "Grade":
            filterMap.Grade.push(val?.grade_id);
            break;
          case "Status":
            filterMap.Status.push(val?.status_id);
            break;
          case "Reviewers":
            filterMap.Reviewers.push(val?.user_id || val?.reviewers_id);
            break;
          case "Source":
            filterMap.Source.push(val?.source_id);
            break;
          case "Created_By":
            filterMap.Created_By.push(val?.created_by_id);
            break;
          default:
            break;
        }
      }
    });


    setState((prevState) => ({
      ...prevState,
      filterValues: filterValues,

      selectedGrades: filterMap.Grade.length > 0 ? filterMap.Grade : null,
      selectedsubjects: filterMap.Subject.length > 0 ? filterMap.Subject : null,
      selectedCategories: filterMap.Category.length > 0 ? filterMap.Category : null,
      selectedAuthors: filterMap.Author.length > 0 ? filterMap.Author : null,
      selectedChapters: filterMap.Chapter.length > 0 ? filterMap.Chapter : null,
      selectedTerms: filterMap.Term.length > 0 ? filterMap.Term : null,
      selectedYears: filterMap.Year.length > 0 ? filterMap.Year : null,
      selectedDifficulties: filterMap.Difficulty.length > 0 ? filterMap.Difficulty : null,
      selectedLanguages: filterMap.Language.length > 0 ? filterMap.Language : null,
      selectedStatuses: filterMap.Status.length > 0 ? filterMap.Status : null,
      selectedReviewers: filterMap.Reviewers.length > 0 ? filterMap.Reviewers : null,
      selectedExamCategories: filterMap.Exam_Category.length > 0 ? filterMap.Exam_Category : null,
      selectedSources: filterMap.Source.length > 0 ? filterMap.Source : null,
      selectedCreatedBys: filterMap.Created_By.length > 0 ? filterMap.Created_By : null,
    }));
    // handlefetchAllMyAssessments();
  };

  const isParentChecked = (filterType) => {
    const filterValues = state.filterValues;
    const childItems = getChildItems(filterType);
    return (
      childItems.length > 0 &&
      childItems.every((child) => {
        const filterKey = filterType.toLowerCase() + '_id';
        const compareKey = filterType === "Reviewers" ? 'user_id' : filterKey;

        return filterValues.some(
          (selectedItem) =>
            selectedItem.filter === filterType &&
            selectedItem[filterKey] === child[compareKey]
        );
      })
    );
    // return (
    // 	childItems.length > 0 &&
    // 	childItems.every((child) =>
    // 		filterValues.some(
    // 			(selectedItem) =>
    // 				selectedItem.filter === filterType &&
    // 				selectedItem[`${filterType.toLowerCase()}_id`] ===
    // 				child[`${filterType.toLowerCase()}_id`]
    // 		)
    // 	)
    // );
  };

  const isParentIndeterminate = (filterType) => {
    const filterValues = state.filterValues;
    const childItems = getChildItems(filterType);
    const selectedCount = childItems.filter((child) =>
      filterValues.some(
        (selectedItem) =>
          selectedItem.filter === filterType &&
          selectedItem[`${filterType.toLowerCase()}_id`] ===
          child[`${filterType.toLowerCase()}_id`]
      )
    ).length;
    return selectedCount > 0 && selectedCount < childItems.length;
  };

  const handleParentCheckboxChange = (filterType, filterItems) => {
    const filterValues = [...state.filterValues];
    const childItems = filterItems

    const allSelected = isParentChecked(filterType);

    let updatedFilterValues;
    if (allSelected) {

      updatedFilterValues = filterValues.filter(
        (item) => item.filter !== filterType
      );
    } else {

      const newSelections = childItems.map((child) => ({
        filter: filterType,
        name: child.name,
        [`${filterType.toLowerCase()}_id`]: child[`${filterType.toLowerCase()}_id`],
      }));
      updatedFilterValues = [
        ...filterValues.filter((item) => item.filter !== filterType),
        ...newSelections,
      ];
    }

    // onSelectFilterMultiProcess(updatedFilterValues);
  };

  const getChildItems = (filterType) => {
    const {
      allCategories,
      allExamCategories,
      allLanguages,
      allSubjects,
      allAuthors,
      allYears,
      allDifficulties,
      allGrades,
      allTerms,
      allChapters,
      allStatuses,
      allReviewers
    } = state;

    switch (filterType) {
      case "Category":
        return allCategories || [];
      case "Exam_Category":
        return allExamCategories || [];
      case "Difficulty":
        return allDifficulties || [];
      case "Language":
        return allLanguages || [];
      case "Subject":
        return allSubjects || [];
      case "Author":
        return allAuthors || [];
      case "Year":
        return allYears || [];
      case "Grade":
        return allGrades || [];
      case "Term":
        return allTerms || [];
      case "Chapter":
        return allChapters || [];
      case "Status":
        return allStatuses || [];
      case "Reviewers":
        return allReviewers || [];
      default:
        return [];
    }
  };

  const clearAllFilters = () => {
    setState((prevState) => ({
      ...prevState,
      filterValues: [],
      selectedAuthors: null,
      selectedsubjects: null,
      selectedChapters: null,
      selectedTerms: null,
      selectedCategories: null,
      selectedYears: null,
      selectedLanguages: null,
      selectedDifficulties: null,
      selectedGrades: null,
      selectedStatuses: null,
      selectedExamCategories: null,
      selectedReviewers: null,
      limit: rowsPerPage, // <-- use the current rowsPerPage
      offset: 0,
    }));
    // handlefetchAllMyAssessments();
  };

  const getCreatedAtLocal = (time) => {
    if (time != null) {
      let timeStamp = new Date(time.concat("Z"))
      let d = new Date(timeStamp)
      // let startDate = d.toDateString();
      // let startTime = d.toLocaleTimeString('en-SL');
      let local = moment(timeStamp).local().format("MMMM Do YYYY hh:mm A")
      return local;
    }
    else {
      return "N/A";
    }
  }

  const handleStartDateChange = (event) => {
    const date = event.target.value;
    const formattedDate = date ? date.replace(/-/g, "") : null;
    setState((prevState) => ({
      ...prevState,
      selectedStartDate: formattedDate,
    }));
    handlefetchAllMyAssessments();
  };

  const handleEndDateChange = (event) => {
    const date = event.target.value;
    const formattedDate = date ? date.replace(/-/g, "") : null;
    setState((prevState) => ({
      ...prevState,
      selectedEndDate: formattedDate,
    }));
    handlefetchAllMyAssessments();
  };

  const clearDateRange = () => {
    setState((prevState) => ({
      ...prevState,
      selectedStartDate: "",
      selectedEndDate: "",
    }));

    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        selectedStartDate: null,
        selectedEndDate: null,
      }));

      handlefetchAllMyAssessments();
    }, 0);
  };

  const handleSearch = (event) => {
    handleSearchInput(event.target.value);
  };

  const displaySubject = (e) => {
    if (e !== null && myAssessments.length > 0) {
      let assessmentSubjects = myAssessments.find(item => 'subjects' in item)?.subjects;
      const subject = assessmentSubjects?.find(
        (subject) => subject.subject_id == e
      );
      return subject?.subject;
    } else {
      return "N/A";
    }
  };

  function getColor(state) {
    switch (state) {
      case "Initial":
        return "label label-lg label-light-primary label-inline";
      case "Ready":
        return "label label-lg label-light-warning label-inline";
      case "Review":
        return "label label-lg label-light-default label-inline";
      case "Published":
        return "label label-lg label-success label-inline";
      case "Retired":
        return "label label-lg label-light-danger label-inline";
      case "InReview":
        return "label label-lg label-light-info label-inline";
      case "ReferBack":
        return "label label-lg label-light-danger label-inline";
      case "ReviewCompleted":
        return "label label-lg label-light-warning label-inline";
      case "ProofReading":
        return "label label-lg label-light-default label-inline";
      case "DataEntryVerification":
        return "label label-lg label-light-primary label-inline";
      default:
        return "label label-lg label-light-info label-inline";
    }
  }

  function getStatusClass(state) {
    const baseClass = "ph-paper-status";
    const stateMap = {
      "Initial": "ph-status-initial",
      "Ready": "ph-status-ready",
      "Review": "ph-status-review",
      "Published": "ph-status-published",
      "Retired": "ph-status-retired",
      "InReview": "ph-status-inreview",
      "ReferBack": "ph-status-referback",
      "ReviewCompleted": "ph-status-reviewcompleted",
      "ReadyToPublish": "ph-status-readytopublish",
      "ProofReading": "ph-status-proofreading",
      "DataEntryVerification": "ph-status-dataentryverification"
    };
    return `${baseClass} ${stateMap[state] || "ph-status-initial"}`;
  }

  const handleClickGetAssesmentContent = async (assessment) => {

    try {

      setIsModalOpen(false)
      setIsAssigned(assessment?.isAssigned);
      setCurrentAssessment(assessment);
      setCurrentAssessmentId(assessment?.assessment_id);
      setCurrentAssessmentStatusId(assessment?.status_id);
      if (currentAssessmentId === assessmentStatusConstants.PROOFREADING.id || currentAssessmentId === assessmentStatusConstants.DATAENTRYVERIFICATION.id) {
        setOperationComplete(assessment?.operation_completed);
      }
      const part_section_data = await assessmentService.getAssessmentPartSectionData(assessment.assessment_id)
      set_assessment_parts(part_section_data.data.parts)
      set_assessment_sections(part_section_data.data.sections)

      await fetchLoadAssesmentQuestionById?.(assessment?.assessment_id);

    } catch (error) {

      console.error('Error fetching assessments:', error);
    }
  };

  const handleGetQuestionContent = async (questions) => {

    try {

      await getAllQuestionContents(questions)

    } catch (error) {

      console.error('Error fetching assessments content', error);
    }
  };

  const handlePageChange = (event, newPage) => {

    const newOffset = newPage * rowsPerPage;

    setState((prevState) => ({
      ...prevState,
      limit: rowsPerPage,
      offset: newOffset
    }));
    setCurrentPage(newPage)

  };

  const handleRowsPerPageChange = (event) => {

    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit)
    localStorage.setItem('assessmentReviewRowsPerPage', newLimit.toString());
    const newPage = Math.floor(state.offset / newLimit);

    setState((prevState) => ({
      ...prevState,
      limit: newLimit,
      offset: newLimit * newPage
    }));
    setCurrentPage(newPage)

  };

  const handlePageOffsetChange = (newOffset, newPage) => {

    setState((prevState) => ({
      ...prevState,
      limit: rowsPerPage,
      offset: newOffset
    }));
    setCurrentPage(newPage)
  };

  const handleSortChange = (column) => {
    setState((prevState) => ({
      ...prevState,
      sort_column: column,
      sort_direction: prevState.sort_direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const handleCommentChange = (question_content_index, value, question_id) => {

    setComments((prevComments) => {
      const updatedComments = [...prevComments];

      const commentIndex = updatedComments.findIndex(
        (comment) => comment.question_id === question_id
      );

      if (commentIndex !== -1) {

        updatedComments[commentIndex] = {
          ...updatedComments[commentIndex],
          comment: value,
        };
      } else {

        updatedComments.push({
          question_content_index,
          question_id,
          comment: value,
          reviewer_id: DataHandler.getFromSession('manage_user_id'),
          reviewer_table_id: DataHandler.getFromSession('table_log_id'),
          review_status: "InReview",
          assesment_id: currentAssessmentId,
          mark_as_reviewed: 0
        });
      }
      // setIsChanged(true);
      return updatedComments;
    });
  };

  const handleSaveComments = async () => {
    try {

      await addUpdateReviewForAssesment(comments, currentAssessmentId)
      // setIsChanged(false);

    } catch (error) {
      console.error('Error saving comments:', error);
      alert('Error saving comments');
    }
  };

  const handleMarkAsReviewForQuestion = useCallback(async (updatedMarkAsReview, currentAssessmentId) => {

    try {

      await markAsReviewForQuestion(updatedMarkAsReview, currentAssessmentId)
      await handleGetReviewComments(currentAssessmentId)
    } catch (error) {

      console.error('Error fetching assessments:', error);
    }
  },
    [currentAssessmentId]
  );

  const handleMarkAsReviewChange = async (question_content_index, value, question_id) => {
    try {
      await sweetConfirmAlertWithChecklist();

      setLoadingStates((prev) => ({ ...prev, [question_id]: true }));

      await markAsReviewForQuestion(
        [
          {
            question_content_index,
            question_id,
            comment: value === 1 ? "1" : "0",
            reviewer_id: DataHandler.getFromSession("manage_user_id"),
            reviewer_table_id: DataHandler.getFromSession("table_log_id"),
            review_status: "InReview",
            assesment_id: currentAssessmentId,
            mark_as_reviewed: value,
          },
        ],
        currentAssessmentId
      );
    } catch {
      console.log("Review not confirmed or cancelled");
    } finally {
      setLoadingStates((prev) => ({ ...prev, [question_id]: false }));
    }
  };


  const handleGetReviewComments = async (assessment_id) => {

    try {

      if (currentAssessmentStatusId === assessmentStatusConstants.PROOFREADING.id || currentAssessmentStatusId === assessmentStatusConstants.DATAENTRYVERIFICATION.id) {
        await fetchAllOperationComments(assessment_id)
      }
      else {
        await fetchAllReviewComments(assessment_id)
        await fetchAllOperationComments(assessment_id)
      }

    } catch (error) {

      console.error('Error fetching assessments reviews', error);
    }
  };

  const handleFinishReview = async (selectedStatus) => {

    try {

      const reviewer_id = DataHandler.getFromSession('manage_user_id')

      const latestReview = currentAssessment?.review_state?.find(
        r => r.is_latest === true
      );

      if (!latestReview.asmnt_review_id) {
        setSnackbar({
          open: true,
          message: "Failed to finish the review",
          severity: 'error'
        });

      }
      else {
        await finishPaperReview(selectedStatus, currentAssessmentId, reviewer_id, latestReview.asmnt_review_id)
      }



    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to finish the review",
        severity: 'error'
      });
    }

  };

  const handleSetForReview = async () => {

    try {

      const reviewer_id = DataHandler.getFromSession('manage_user_id');

      if (!comments[0]?.asmnt_review_id) {
        setSnackbar({
          open: true,
          message: "Failed to set for the review",
          severity: 'error'
        });

      }
      else {
        const result = await setReview(currentAssessmentStatusId, currentAssessmentId, comments[0]?.asmnt_review_id, reviewer_id)

        if (!result.success) {
          sweetStatusAlert("Failed", result.message || "Could not set for review!", "error");
          return;
        }
        else {
          sweetStatusAlert("Success", result.message || "Set for review successfully!", "success");
          setIsModalOpen(false);
          handlefetchAllMyAssessments();
          return;
        }
      }

    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to set for the review",
        severity: 'error'
      });
    }

  };

  const handleFinishOperation = async () => {

    try {

      const employee_id = DataHandler.getFromSession('manage_user_id')

      const latestOperationComment = currentAssessment?.review_state?.find(
        r => r.is_operation_latest === true
      );

      if (!latestOperationComment.asmnt_operation_id) {
        setSnackbar({
          open: true,
          message: "Failed to finish the operation",
          severity: 'error'
        });

      }
      else {
        await finishPaperOperation(currentAssessmentStatusId, currentAssessmentId, employee_id, latestOperationComment.asmnt_operation_id)
      }

    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to finish the operation",
        severity: 'error'
      });
    }

  };

  const handleFinalizeReview = async () => {
    const latestReview = currentAssessment?.review_state?.find(
      r => r.is_latest === true && r.status === assessmentStatusConstants.READYTOPUBLISH.name
    );
    if (!latestReview) {
      setSnackbar({
        open: true,
        message: "Failed to publish paper, please refresh screen",
        severity: 'error'
      });
    }
    else {
      const reviewer_id = DataHandler.getFromSession('manage_user_id')
      await finalizePaper(currentAssessmentId, latestReview.asmnt_review_id, reviewer_id)
    }

  };

  // Handle changes to the paper filter
  const handlePaperFilterChange = () => {
    const newValue = paperSwitchOptions.value === paperFilterOptions[0].value
      ? paperFilterOptions[1]
      : paperFilterOptions[0];

    setPaperSwitchOptions(newValue);
  };

  const handleSubCommentModal = (question_content_index, question_id) => {
    if (subCommentModal) {
      setCurrentQIndex(null);
      setCurrentquestionId(null);
      setSubCommentModal(false);
    } else {
      setCurrentQIndex(question_content_index);
      setCurrentquestionId(question_id);
      setSubCommentModal(true);
    }
  };

  const handleSubOperationCommentModal = () => {

    if (subCommentModal) {
      setSubCommentModal(false);
    } else {
      setSubCommentModal(true);
    }
  };

  const handleSaveSubReviewComment = async () => {

    let validReviewState = null;
    try {

      if (currentAssessment) {



        if (currentAssessment && Array.isArray(currentAssessment.review_state)) {

          if (currentAssessmentStatusId === assessmentStatusConstants.ReviewCompleted.id) {

            validReviewState = currentAssessment.review_state.find(
              (rs) =>
                rs.status === assessmentStatusConstants.REVIEW.name ||
                rs.status === assessmentStatusConstants.INREVIEW.name ||
                rs.status === assessmentStatusConstants.ReviewCompleted.name
            );
          }
          else {
            validReviewState = currentAssessment.review_state.find(
              (rs) =>
                rs.is_assigned === true &&
                rs.is_latest === true &&
                (rs.status === assessmentStatusConstants.REVIEW.name || rs.status === assessmentStatusConstants.INREVIEW.name)
            );
          }


          if (validReviewState && validReviewState.asmnt_review_id) {


            try {

              const newComment = {
                currentQIndex,
                comment: subComment,
                reviewer_id: DataHandler.getFromSession('manage_user_id'),
                reviewer_table_id: DataHandler.getFromSession('table_log_id'),
                review_status: currentAssessmentStatusId === assessmentStatusConstants.ReviewCompleted.id ? assessmentStatusConstants.ReviewCompleted.name : "InReview",
                assesment_id: currentAssessmentId,
                mark_as_reviewed: currentAssessmentStatusId === assessmentStatusConstants.ReviewCompleted.id ? 1 : 0,
                question_id: currentquestionId,
                asmnt_review_id: validReviewState.asmnt_id,
                review_id: validReviewState.asmnt_review_id
              }

              await addSubReviewForAssesment(newComment, currentAssessmentId)

            } catch (error) {
              return (
                <Snackbar open={true} autoHideDuration={3000}>
                  <Alert
                    severity="Failed"
                    variant="filled"
                    sx={{ width: '100%' }}
                  >
                    Failed to add comment
                  </Alert>
                </Snackbar>
              )
            }
          }
          else {

            return (
              <Snackbar open={true} autoHideDuration={3000}>
                <Alert
                  severity="Failed"
                  variant="filled"
                  sx={{ width: '100%' }}
                >
                  Failed to add comment
                </Alert>
              </Snackbar>
            )

          }
        }
        else {
          return (
            <Snackbar open={true} autoHideDuration={3000}>
              <Alert
                severity="Failed"
                variant="filled"
                sx={{ width: '100%' }}
              >
                Failed to add comment 22
              </Alert>
            </Snackbar>
          )
        }
      }
      else {
        return (
          <Snackbar open={true} autoHideDuration={3000}>
            <Alert
              severity="Failed"
              variant="filled"
              sx={{ width: '100%' }}
            >
              Failed to add comment
            </Alert>
          </Snackbar>
        )
      }
    } catch (error) {

      return (
        <Snackbar open={true} autoHideDuration={3000}>
          <Alert
            severity="Failed"
            variant="filled"
            sx={{ width: '100%' }}
          >
            Failed to add comment
          </Alert>
        </Snackbar>
      )
    }

  };

  const handleSaveSubOperationComment = async () => {

    let validOperationState = null;
    try {

      if (currentAssessment) {

        if (currentAssessment && Array.isArray(currentAssessment.review_state)) {

          validOperationState = currentAssessment.review_state.find(
            (rs) =>
              rs.is_assigned === true &&
              rs.is_operation_latest === true &&
              (rs.status === assessmentStatusConstants.PROOFREADING.name || rs.status === assessmentStatusConstants.DATAENTRYVERIFICATION.name)
          );

          if (validOperationState && validOperationState.asmnt_operation_id) {
            const newComment = {
              comment: subComment,
              assessment_id: currentAssessmentId,
              employee_id: DataHandler.getFromSession('manage_user_id'),
            }

            try {

              await addOperationCommentForAssessment(newComment, currentAssessmentId)

            } catch (error) {

              return (
                <Snackbar open={true} autoHideDuration={3000}>
                  <Alert
                    severity="Failed"
                    variant="filled"
                    sx={{ width: '100%' }}
                  >
                    Failed to add comment
                  </Alert>
                </Snackbar>
              )
            }
          }
          else {

            return (
              <Snackbar open={true} autoHideDuration={3000}>
                <Alert
                  severity="Failed"
                  variant="filled"
                  sx={{ width: '100%' }}
                >
                  Failed to add comment 33
                </Alert>
              </Snackbar>
            )

          }
        }
        else {
          return (
            <Snackbar open={true} autoHideDuration={3000}>
              <Alert
                severity="Failed"
                variant="filled"
                sx={{ width: '100%' }}
              >
                Failed to add comment 22
              </Alert>
            </Snackbar>
          )
        }
      }
      else {
        return (
          <Snackbar open={true} autoHideDuration={3000}>
            <Alert
              severity="Failed"
              variant="filled"
              sx={{ width: '100%' }}
            >
              Failed to add comment
            </Alert>
          </Snackbar>
        )
      }
    } catch (error) {

      return (
        <Snackbar open={true} autoHideDuration={3000}>
          <Alert
            severity="Failed"
            variant="filled"
            sx={{ width: '100%' }}
          >
            Failed to add comment
          </Alert>
        </Snackbar>
      )
    }

  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const validateAllQuestionsReviewed = () => {

    const allQuestionIds = questions.map((question) => question.question_id);


    return allQuestionIds.every((questionId) => {
      const reviewComment = markAsReview.find(
        (review) => review.question_id === questionId
        // && review.comment_type === "REVIEW"
      );
      return reviewComment && (reviewComment.mark_as_reviewed === 1 || reviewComment.mark_as_reviewed === true);
    });
  };

  const handleReviewModal = (assessment) => {
    setAddReviewLoading(true);
    if (assessment) {
      const latestReview = assessment.review_state?.find(r => r.is_latest === true);
      const latestOperation = assessment.review_state?.find(r => r.is_operation_latest === true);
      if (assessment?.status_id === assessmentStatusConstants.PROOFREADING.id || assessment?.status_id === assessmentStatusConstants.DATAENTRYVERIFICATION.id) {
        setSelectedOperation(assessment?.status_id);
        setSelectedReviewer(latestOperation?.employee_id || '');
        setOperationComplete(assessment?.operation_completed);
        setselectedAssessmentOperationId(latestOperation?.asmnt_operation_id || '')
      }
      else if (assessment?.status_id === assessmentStatusConstants.REVIEW.id || assessment?.status_id === assessmentStatusConstants.INREVIEW.id || assessment?.status_id === assessmentStatusConstants.ReviewCompleted.id || assessment?.status_id === assessmentStatusConstants.REFERBACK.id) {
        setSelectedOperation(assessmentStatusConstants.REVIEW.id);
        setSelectedReviewer(latestReview?.teacher_id || '');
        setOperationComplete(false);
        setselectedAssessmentOperationId(latestReview?.asmnt_review_id || '')
      }
      else {
        setSelectedOperation(null);
        setSelectedReviewer(null);
        setOperationComplete(false);
        setselectedAssessmentOperationId(null);
      }
      setSelectedAssessment(assessment);
      setReviewerModal(true);
    } else {
      setSelectedOperation(null);
      setSelectedReviewer(null);
      setSelectedAssessment(null);
      setOperationComplete(false);
      setselectedAssessmentOperationId(null);
      setReviewerModal(false);
    }
    setAddReviewLoading(false);
  };

  const fetchEmployeesForDropdown = async (selectedOperation) => {
    try {
      setReviewerLoading(true);

      const teacherRoles = ["TEACH"];
      const operatorRoles = ["MASAD", "DEOP"];

      let employeeResponse;

      if (selectedOperation === assessmentStatusConstants.REVIEW.id) {
        employeeResponse = await manageUserService.getTeachersforDropdown(teacherRoles);
      }
      if (selectedOperation === assessmentStatusConstants.PROOFREADING.id || selectedOperation === assessmentStatusConstants.DATAENTRYVERIFICATION.id) {
        employeeResponse = await manageUserService.getTeachersforDropdown(operatorRoles);
      }

      if (employeeResponse.success) {
        setReviewersList(employeeResponse.data)
        setReviewerLoading(false);
      } else {
        setReviewersList([]);
        setReviewerLoading(false);
      }
    } catch (error) {
      setReviewersList([]);
      setReviewerLoading(false);
    }
  };

  const fetchAssessmentStatusesForDropdown = async () => {
    try {
      setOperationLoading(true);

      const statusIds = [
        assessmentStatusConstants.REVIEW.id,
        assessmentStatusConstants.PROOFREADING.id
      ];

      const statusResponse = await assessmentStatusService.getAllAssessmentStatusesByIds(statusIds);

      if (statusResponse.success) {
        setAssessmentStatusesList(statusResponse.data.statuses)
        setOperationLoading(false);
        setReviewerLoading(false);

      } else {
        setAssessmentStatusesList([])
        setOperationLoading(false);
        setReviewerLoading(false);
      }
    } catch (error) {
      setAssessmentStatusesList([])
      setOperationLoading(false);
      setReviewerLoading(false);
    }
  };

  const handleAssignReviewer = async () => {

    setAddReviewLoading(true)
    if (!selectedOperation) {
      sweetStatusAlert("Warning", "Select the operation before assigning!", "info")
      setAddReviewLoading(false)
      return
    }
    if (!selectedReviewer) {
      sweetStatusAlert("Warning", "Select the reviewer before assigning!", "info")
      setAddReviewLoading(false)
      return
    }
    if (!selectedAssessment) {
      sweetStatusAlert("Warning", "Assessment not selected!", "info")
      setAddReviewLoading(false)
      return
    }
    else {

      try {

        const assign_by = DataHandler.getFromSession('manage_user_id');

        const result = await assignReviewer(
          selectedReviewer,
          selectedAssessment.assessment_id,
          assign_by
        )

        setAddReviewLoading(false);

        if (!result.success) {
          sweetStatusAlert("Failed", result.message || "Could not assign employee!", "error");
          return;
        }
        else {
          sweetStatusAlert("Success", result.message || "Assigned employee successfully!", "success");
          handleReviewModal(null)
          handlefetchAllMyAssessments();
          return;
        }

      } catch (error) {
        setAddReviewLoading(false)
        setSnackbar({
          open: true,
          message: "Failed to add reviewer!",
          severity: 'error'
        });
      }
    }

  };

  const handleChangeAssignedReviewer = async () => {

    setAddReviewLoading(true)
    if (!selectedOperation) {
      sweetStatusAlert("Warning", "Select the operation before updating!", "info")
      setAddReviewLoading(false)
      return
    }
    if (!selectedReviewer) {
      sweetStatusAlert("Warning", "Select the reviewer before updating!", "info")
      setAddReviewLoading(false)
      return
    }
    if (!selectedAssessment) {
      sweetStatusAlert("Warning", "Assessment not selected!", "info")
      setAddReviewLoading(false)
      return
    }
    else {

      try {

        const assign_by = DataHandler.getFromSession('manage_user_id');

        const result = await changeAssignedReviewer(
          selectedReviewer,
          selectedAssessmentOperationId,
          assign_by
        );

        setAddReviewLoading(false);

        if (!result.success) {
          sweetStatusAlert("Failed", result.message || "Could not change assigned employee!", "error");
          return;
        }
        else {
          sweetStatusAlert("Success", result.message || "Assigned employee changed successfully!", "success");
          handleReviewModal(null)
          handlefetchAllMyAssessments();
          return;
        }

      } catch (error) {
        setAddReviewLoading(false)
        setSnackbar({
          open: true,
          message: "Failed to change assigned reviewer!",
          severity: 'error'
        });
      }
    }

  };

  const handleAssignOperator = async () => {

    setAddReviewLoading(true)
    if (!selectedOperation) {
      sweetStatusAlert("Warning", "Select the operation before assigning!", "info")
      setAddReviewLoading(false)
      return
    }
    if (!selectedReviewer) {
      sweetStatusAlert("Warning", "Select the employee before assigning!", "info")
      setAddReviewLoading(false)
      return
    }
    if (!selectedAssessment) {
      sweetStatusAlert("Warning", "Assessment not selected!", "info")
      setAddReviewLoading(false)
      return
    }
    else {

      try {

        const assign_by = DataHandler.getFromSession('manage_user_id');

        const result = await assignOperator(
          selectedReviewer,
          selectedAssessment.assessment_id,
          assign_by,
          selectedOperation
        );

        setAddReviewLoading(false);

        if (!result.success) {
          sweetStatusAlert("Failed", result.message || "Could not assign employee", "error");
          return;
        }
        else {
          sweetStatusAlert("Success", result.message || "Assigned employee successfully!", "success");
          handleReviewModal(null)
          handlefetchAllMyAssessments();
          return;
        }

      } catch (error) {
        setAddReviewLoading(false)
        setSnackbar({
          open: true,
          message: "Failed to add operator!",
          severity: 'error'
        });
      }
    }

  };

  const handleChangeAssignedOperator = async () => {

    setAddReviewLoading(true)
    if (!selectedOperation) {
      sweetStatusAlert("Warning", "Select the operation before updating!", "info")
      setAddReviewLoading(false)
      return
    }
    if (!selectedReviewer) {
      sweetStatusAlert("Warning", "Select the employee before updating!", "info")
      setAddReviewLoading(false)
      return
    }
    if (!selectedAssessment) {
      sweetStatusAlert("Warning", "Assessment not selected!", "info")
      setAddReviewLoading(false)
      return
    }
    else {

      try {

        const assign_by = DataHandler.getFromSession('manage_user_id');

        const result = await changeAssignedOperator(
          selectedReviewer,
          selectedAssessmentOperationId,
          assign_by
        );

        setAddReviewLoading(false);

        if (!result.success) {
          sweetStatusAlert("Failed", result.message || "Could not change assigned employee", "error");
          return;
        }
        else {
          sweetStatusAlert("Success", result.message || "Assigned employee changed successfully!", "success");
          handleReviewModal(null)
          handlefetchAllMyAssessments();
          return;
        }

      } catch (error) {
        setAddReviewLoading(false)
        setSnackbar({
          open: true,
          message: "Failed to change assigned operator!",
          severity: 'error'
        });
      }
    }

  };

  const handleOpenAssessmentStatusDialog = () => {
    if (!selectedAssessment) {
      sweetStatusAlert("Warning", "Assessment not selected!", "info");
      return;
    }

    setSelectedAssessmentStatus("");
    setOpenAssessmentStatusDialog(true);
  };

  const handleUpdateAssessmentStatus = async () => {
    setAddReviewLoading(true);

    if (!selectedAssessment) {
      sweetStatusAlert("Warning", "Assessment not selected!", "info");
      setAddReviewLoading(false);
      return;
    }

    if (!selectedAssessmentStatus) {
      sweetStatusAlert("Warning", "Select the status before updating!", "info");
      setAddReviewLoading(false);
      return;
    }

    try {
      const result = await assessmentService.update_assessment_status(
        selectedAssessment?.assessment_id,
        selectedAssessmentStatus
      );

      setAddReviewLoading(false);

      if (!result.success) {
        sweetStatusAlert(
          "Failed",
          result.message || "Could not update assessment status!",
          "error"
        );
        return;
      }

      sweetStatusAlert(
        "Success",
        result.message || "Assessment status updated successfully!",
        "success"
      );

      setOpenAssessmentStatusDialog(false);
      handleReviewModal(null);
      handlefetchAllMyAssessments();
      return;

    } catch (error) {
      setAddReviewLoading(false);
      setOpenAssessmentStatusDialog(false);
      setSnackbar({
        open: true,
        message: "Failed to update assessment status!",
        severity: "error"
      });
    }
  };

  const handleResetAssessmentReview = async () => {
    setAddReviewLoading(true);

    if (!selectedAssessment) {
      sweetStatusAlert("Warning", "Assessment not selected!", "info");
      setAddReviewLoading(false);
      return;
    }

    try {
      const result = await assessmentService.reset_assessment_review(
        selectedAssessment?.assessment_id
      );

      setAddReviewLoading(false);

      if (!result.success) {
        sweetStatusAlert(
          "Failed",
          result.message || "Could not reset assessment review!",
          "error"
        );
        return;
      }

      sweetStatusAlert(
        "Success",
        result.message || "Assessment review reset successfully!",
        "success"
      );

      handleReviewModal(null);
      handlefetchAllMyAssessments();
      return;

    } catch (error) {
      setAddReviewLoading(false);
      setSnackbar({
        open: true,
        message: "Failed to reset assessment review!",
        severity: "error"
      });
    }
  };

  const handleSetForReviewByCompleted = async (type) => {

    try {

      const reviewer_id = DataHandler.getFromSession('manage_user_id');

      if (!comments[0]?.asmnt_review_id) {
        setSnackbar({
          open: true,
          message: "Failed to set for the review",
          severity: 'error'
        });

      }
      else {
        const result = await finishPaperReviewByCompleted(currentAssessmentId, reviewer_id, comments[0]?.asmnt_review_id, type)

        if (!result.success) {
          sweetStatusAlert("Failed", result.message ? result.message : "Failed to set for review!", "error");
          return;
        }
        else {
          sweetStatusAlert("Success", result.message ? result.message : "Set for review successfully!", "success");
          setIsModalOpen(false);
          handlefetchAllMyAssessments();
          return;
        }
      }

    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to set for the review",
        severity: 'error'
      });
    }

  };

  const handleSetForPublishByCompleted = async () => {

    try {

      const reviewer_id = DataHandler.getFromSession('manage_user_id');

      if (!comments[0]?.asmnt_review_id) {
        setSnackbar({
          open: true,
          message: "Failed to set for the publish",
          severity: 'error'
        });

      }
      else {
        const result = await setPaperToPublish(currentAssessmentId, comments[0]?.asmnt_review_id, reviewer_id)

        if (!result.success) {
          sweetStatusAlert("Failed", result.message || "Failed to set for publish!", "error");
          return;
        }
        else {
          sweetStatusAlert("Success", result.message || "Set for publish successfully!", "success");
          setIsModalOpen(false);
          handlefetchAllMyAssessments();
          return;
        }
      }

    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to set for the publish",
        severity: 'error'
      });
    }

  };

  const getQuestionPassageContent = (content) => {
    let states = JSON.parse(content);
    let passageContentState = EditorState.createWithContent(convertFromRaw(states[0]));
    return passageContentState;
  }

  useEffect(() => {
    if (assign_reviewer) {
      setAddReviewLoading(false)
      handleReviewModal(null)
      // setSnackbar({
      // 	open: true,
      // 	message: "Employee assigned for the operation",
      // 	severity: 'success'
      // });
      handlefetchAllMyAssessments();
      sweetStatusAlert("Success", "Employee assigned for the operation", "success")
    }
  }, [assign_reviewer])

  useEffect(() => {
    if (reviewerModal) {
      fetchAssessmentStatusesForDropdown();
    }
  }, [reviewerModal]);

  useEffect(() => {
    if (selectedOperation) {
      fetchEmployeesForDropdown(selectedOperation);
    }
  }, [selectedOperation]);

  useEffect(() => {
    fetchAllAssessmentMetaData()
  }, [])

  useEffect(() => {
    handlefetchAllMyAssessments();
  }, [paperSwitchOptions]);

  useEffect(() => {
    setIsModalOpen(false)
    setEmployeeType(sessionStorage.getItem("employeeType"))
    handlefetchAllMyAssessments();
  }, [
    state.limit,
    state.offset,
    state.sort_column,
    state.sort_direction,
    state.search_term,
    state.filterValues,
    state.selectedGrades,
    state.selectedChapters,
    state.selectedsubjects,
    state.selectedAuthors,
    state.selectedYears,
    state.selectedCategories,
    state.selectedTerms,
    state.selectedDifficulties,
    state.selectedLanguages,
    state.selectedStatuses,
    state.selectedExamCategories,
    state.selectedReviewers,
    state.selectedStartDate,
    state.selectedEndDate,
    state.totalCount,
    state.gradeCounts,
    state.subjectCounts,
    state.languageCounts,
    state.examCategoryCounts,
    state.sourceCounts,
    state.authorCounts,
    state.categoryCounts,
    state.difficultyCounts,
    state.chapterCounts,
    state.yearCounts,
    state.termCounts,
    state.statusCounts,
    state.createdByCounts,
    state.reviewerCount,
  ]);

  useEffect(() => {


    if (history?.location?.state?.value) {
      const selectedStatusFilterFromNav = history.location.state;
      const statusId = selectedStatusFilterFromNav.value;

      setState((prevState) => {
        const updatedFilterValues = [
          ...prevState.filterValues.filter((f) => f.filter !== "Status"),
          {
            filter: "Status",
            name: selectedStatusFilterFromNav.name,
            status_id: statusId,
          },
        ];

        return {
          ...prevState,
          selectedStatuses: [statusId],
          filterValues: updatedFilterValues,
        };
      });
    }

  }, []);

  useEffect(() => {
    setIsModalOpen(false)
    return () => {
      setIsFinishReviewModalOpen(false)
      setCurrentAssessmentId(null)
      setCurrentAssessmentStatusId(null)
      setOperationComplete(false)
      setCurrentAssessment(null)
      setIsModalOpen(false)
      setIsAssigned(false)
      handlefetchAllMyAssessments.cancel();
    };
  }, []);

  useEffect(() => {

    if (assmnt_content) {

      let subQuestionsObject = {};

      if (Array.isArray(assmnt_content)) {

        assmnt_content.forEach((item, index) => {

          if (item.is_subquestion === "true") {

            subQuestionsObject[item.question_id] = item;

          }
        });

        let subQuestionsIndexes = assmnt_content.map((item, index) => item.is_subquestion === "true" ? index : null)
          .filter(index => index !== null);

        setSubQuestions(subQuestionsObject)
        setSubQuestionsIndexes(subQuestionsIndexes)

        setQuestions(assmnt_content.filter(item => item.is_subquestion !== "true"))

        setIsModalOpen(true)

        try {
          // handleGetQuestionContent(assmnt_content)
          handleGetReviewComments(currentAssessmentId)
        } catch (error) {
          console.error("assmnt_content is not valid:", error);
        }
      }
      else {
        console.error("assmnt_content is not valid:");
      }

    }
  }, [assmnt_content])


  useEffect(() => {

    if (questions && questions.length > 0) {

      setQuestionRefs(questions.map(() => React.createRef()))

    }

  }, [questions])

  useEffect(() => {
    if (asmnt_details && Object.keys(asmnt_details).length > 0) {
      setAssessmentDetails(asmnt_details);
    }
  }, [asmnt_details]);

  useEffect(() => {

    if (assmnt_content && assmnt_content.length > 0 && questions && questions.length > 0 && subQuestionsIndexes) {

      let indexes = subQuestionsIndexes;
      let subQuestions = {};


      indexes.forEach(index => {
        if (assmnt_content.hasOwnProperty(index)) {
          subQuestions[index] = assmnt_content[index];
        }
      });


      let filteredQuestions = assmnt_content.filter((item, index) => !indexes.includes(index));

      const hasParts = assessment_parts && assessment_parts.length > 0;

      let localIndexMap = {};

      const questionsWithLocalIndex = filteredQuestions.map(q => {
        if (hasParts) {
          const sectionId = q.section_id;

          if (!localIndexMap[sectionId]) {
            localIndexMap[sectionId] = 0;
          }

          const localIndex = localIndexMap[sectionId];
          localIndexMap[sectionId] += 1;

          return {
            ...q,
            localIndex,
          };
        } else {
          return {
            ...q,
            localIndex: filteredQuestions.indexOf(q)
          };
        }
      });

      let questionStates = {};

      let question_content = questionsWithLocalIndex?.map((question, i) => {


        let tempAnswerStates = []


        let states = question?.content ? JSON.parse(question?.content) : [];


        let tempQuestionState = states.length > 0 && states[0]
          ? EditorState.createWithContent(convertFromRaw(states[0]))
          : EditorState.createEmpty();

        let guidenceState = question?.guidence ? JSON.parse(question?.guidence) : [];

        let tempGuidenceState = guidenceState.length > 0 && guidenceState[0]
          ? EditorState.createWithContent(convertFromRaw(guidenceState[0]))
          : EditorState.createEmpty();


        questionStates[question.question_id] = {
          tempQuestionState,
          tempGuidenceState,
          type: question?.question_type
        };

        if (question?.question_type === questionTypeConstants.DESCRIPTIVE.name) {

          let tempAnswer = question && question?.answer ? JSON.parse(question.answer) : []

          let tempAnswerState = tempAnswer.length > 0 && tempAnswer[0]
            ? EditorState.createWithContent(convertFromRaw(tempAnswer[0]))
            : EditorState.createEmpty();

          questionStates[question.question_id].tempAnswerState = tempAnswerState;
          questionStates[question.question_id].mark_allocation = question.mark_allocation

          return (
            <div className="col-md-12" style={{ overflow: "auto" }} key={i}>
              {question.is_passage && question.passage_id && question.passage_content &&
                <>
                  <div className="mb-5 mt-5">
                    <CustomEditor editorState={getQuestionPassageContent(question.passage_content)} />
                  </div>
                  <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
                </>
              }
              <h3 className="d-flex mb-5 overflow-hidden all-questions-title">

                <div className="number-wrap" style={{ fontSize: "12px", marginTop: "3px" }}>{question.localIndex + 1}.</div>
                <div className="rdw-editor-question">
                  <CustomEditor editorState={tempQuestionState} />
                </div>
                {/* <div className="pl-2 pr-2 border border-primary rounded d-inline-block push-button">
									<CheckBoxInline>
										<CheckBox
											key={i}
											// onClick={(e) => makeRevise(e, i)}
											checked={question.needToRevise || false}
											checkBoxName="Mark for Review"
											style={{ color: "#5458AF" }}
										/>
									</CheckBoxInline>
								</div> */}
              </h3>

              <div className="RichEditor-root-descriptive-answer" key={i} id="editAnswer">

                <Typography variant="h6" gutterBottom>
                  <DoneAllIcon />
                  <u>Sample Answer</u>
                </Typography>

                <CustomEditor editorState={tempAnswerState} />

                <Divider />
                <span style={{
                  color: '#2e7d32',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  backgroundColor: '#e8f5e9',
                  padding: '2px 8px',
                  borderRadius: '4px'
                }}>
                  Allocated Marks: {question.mark_allocation || "0.0"}
                </span>
                <Typography variant="h6" gutterBottom>
                  <LiveHelpIcon />
                  <u> Marking Guidance</u>
                </Typography>
                <CustomEditor editorState={tempGuidenceState} />
                {/* <Editor
									placeholder="Add your answer here..."
									editorStyle={{ height: "200px" }}
									editorState={tempAnswerState}
									key={i}
									toolbarHidden
									// onEditorStateChange={(e) => makeEdit(e, i, question.question_id)}
									toolbar={{
										fontFamily: {
											options: [
												"Arial",
												"Georgia",
												"Impact",
												"Tahoma",
												"Times New Roman",
												"Verdana",
												"Kushpoo",
												"Baamini",
												"FMAbhaya"
											],
										},
									}}
									toolbarClassName="vertical-toolbar"
								/> */}
              </div>
              <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
            </div>
          );
        }
        else if (question?.question_type === questionTypeConstants.SUBQUESTION.name && question?.sub_questions && subQuestions) {
          const subQuestionIds = question.sub_questions.split(",").map(id => id.trim());
          const sub_ques = {};

          // Match sub-questions using question_id from the list
          Object.entries(subQuestions).forEach(([key, val]) => {
            if (subQuestionIds.includes(val.question_id.toString())) {
              sub_ques[key] = val;
            }
          });

          let subQuestionStates = {};

          return (
            <div className="col-md-12" style={{ overflow: "auto" }} key={i}>
              {/* Passage Block */}
              {question.is_passage && question.passage_id && question.passage_content && (
                <>
                  <div className="mb-5 mt-5">
                    <CustomEditor editorState={getQuestionPassageContent(question.passage_content)} />
                  </div>
                  <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
                </>
              )}

              {/* Main Question Title */}
              <div className="row">
                <div className="col-md-12 pt-3 mb-5">
                  <div className="row">
                    <div className="col-md-1 col-1 number-wrap" style={{ fontWeight: "600", fontSize: "12px", marginTop: "3px" }}>{question.localIndex + 1}.</div>
                    <div className="col-md-11 col-11 rdw-editor-question overflow-hidden all-questions-title" style={{ fontWeight: "600" }}>
                      <CustomEditor editorState={tempQuestionState} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Sub Questions */}
              {Object.entries(sub_ques).map(([key, val], j) => {
                const state = val?.content ? JSON.parse(val.content) : [];
                const answer = val?.answer ? JSON.parse(val.answer)[0] : null;

                const tempQuestion = EditorState.createWithContent(convertFromRaw(state[0]));
                const tempAnswer = EditorState.createWithContent(convertFromRaw(answer));

                subQuestionStates[val.question_id] = {
                  tempQuestion,
                  tempAnswer,
                  mark_allocation: val.mark_allocation || 0
                };

                // Save in main questionStates
                questionStates[question.question_id].subQuestions = subQuestionStates;

                return (
                  <div className="col-md-12 ml-5 pl-5" key={j}>
                    <div className="row d-flex align-items-center">
                      <div className="col-md-1 col-1 number-wrap" style={{ fontWeight: "600", fontSize: "12px", marginTop: "3px" }}>{j + 1}.</div>
                      <div className="col-md-11 col-11 rdw-editor-question" style={{ fontWeight: "500" }}>
                        <CustomEditor editorState={tempQuestion} />
                      </div>
                    </div>

                    {/* Sample Answer + Marks */}
                    <div className="RichEditor-root-descriptive-answer" id="editAnswer">
                      <Typography variant="h6" gutterBottom>
                        <DoneAllIcon />
                        <u>Sample Answer</u>
                        <span style={{
                          color: '#2e7d32',
                          fontWeight: 600,
                          fontSize: '0.9rem',
                          backgroundColor: '#e8f5e9',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          marginLeft: '12px'
                        }}>
                          Allocated Marks: {val.mark_allocation || "0.0"}
                        </span>
                      </Typography>
                      <CustomEditor editorState={tempAnswer} />
                    </div>

                    {/* Separator between sub-questions */}
                    {j !== Object.keys(sub_ques).length - 1 && (
                      <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
                    )}
                  </div>
                );
              })}

              {/* Guidance Block */}
              <Divider />
              <Typography variant="h6" gutterBottom>
                <LiveHelpIcon />
                <u>Marking Guidance</u>
              </Typography>
              <CustomEditor editorState={tempGuidenceState} />
              <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
            </div>
          );
        }
        else if (question?.question_type === questionTypeConstants.MCQ.name) {


          // states.shift();
          try {
            const answerStates = states.slice(1);
            answerStates.forEach((state) => {

              if (state) {
                const editorState = EditorState.createWithContent(convertFromRaw(state));
                tempAnswerStates.push(editorState);
              }
              else {
                console.error("Failed to convert answer state:")
                // tempAnswerStates.push(EditorState.createEmpty());
              }

            });
          } catch (e) {
            console.error("Failed to convert answer state:", e)
            // tempAnswerStates.push(EditorState.createEmpty());
          }
          // answerStates.forEach((state) => {
          // 	tempAnswerStates.push(EditorState.createWithContent(convertFromRaw(state)));
          // });

          questionStates[question.question_id].tempAnswerStates = tempAnswerStates;

          questionStates[question.question_id].tempAnswerTypeId = question.answer_type_id;
          questionStates[question.question_id].tempMcqAnswer = question.answer
          questionStates[question.question_id].mark_allocation = question.mark_allocation

          return (
            <div className="col-md-12 px-0" style={{ overflow: "auto" }} key={i}>
              {/* Passage content if exists */}
              {question.is_passage && question.passage_id && question.passage_content && (
                <>
                  <div className="mb-5 mt-5">
                    <CustomEditor editorState={getQuestionPassageContent(question.passage_content)} />
                  </div>
                  <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
                </>
              )}

              {/* Question title */}
              <h3 className="mb-5 overflow-hidden all-questions-title">
                <div className="d-flex">
                  <div className="number-wrap" style={{ fontSize: "12px", marginTop: "3px" }}>
                    {question.localIndex + 1}.
                  </div>
                  <div className="rdw-editor-question">
                    <CustomEditor editorState={tempQuestionState} />
                  </div>
                </div>
              </h3>

              {/* Answer options */}
              <div>
                {tempAnswerStates.length > 0 ? (
                  <>
                    <div className={`RichEditor-root px-0 parent-class ${tempAnswerStates.some(answer => answer.getCurrentContent().getPlainText().length > 100)
                      ? "single-column"
                      : ""
                      }`}>
                      {tempAnswerStates.map((answer, j) => (
                        <div className="row d-flex align-items-center child-class" key={j}>
                          <div className="col-md-2 col-2">
                            {question.answer_type_id === questionMCQAnswerTypeConstants.One.id ? (
                              <RadioInline className="col-md-1">
                                <Radio
                                  key={j}
                                  checked={question.answer && parseFloat(question.answer.split(",")[j]?.trim()) > 0}
                                  style={{ color: "#5458AF" }}
                                  value={j}
                                />
                              </RadioInline>
                            ) : (
                              <CheckBoxInline className="col-md-1">
                                <CheckBox
                                  key={j}
                                  checked={
                                    question.answer &&
                                    parseFloat(question.answer.split(",")[j]?.trim()) > 0
                                  }
                                  style={{ color: "#5458AF" }}
                                />
                              </CheckBoxInline>
                            )}
                          </div>
                          <div className="col-md-10 col-10">
                            <CustomEditor editorState={answer} />
                          </div>
                        </div>
                      ))}
                    </div>
                    <Divider />
                    <span style={{
                      color: '#2e7d32',
                      fontWeight: 600,
                      fontSize: '0.9rem',
                      backgroundColor: '#e8f5e9',
                      padding: '2px 8px',
                      borderRadius: '4px'
                    }}>
                      Allocated Marks: {question.mark_allocation || "0.0"}
                    </span>
                    <Typography variant="h6" gutterBottom>
                      <LiveHelpIcon />
                      <u> Marking Guidance</u>
                    </Typography>
                    <CustomEditor editorState={tempGuidenceState} />
                  </>
                ) : (
                  <div className="alert alert-warning">
                    No content found for this question
                  </div>
                )}
              </div>
              <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
            </div>
          );

          // return (

          // 	<div className="col-md-12 px-0" style={{ overflow: "auto" }} key={i}>
          // 		{question.is_passage && question.passage_id && question.passage_content &&
          // 			<>
          // 			<div className="mb-5 mt-5">
          // 				<CustomEditor editorState={getQuestionPassageContent(question.passage_content)} />
          // 			</div>
          // 			<div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
          // 			</>
          // 		}
          // 		<h3 className="mb-5 overflow-hidden all-questions-title">

          // 			<div className="d-flex">
          // 				<div className="number-wrap" style={{ fontSize: "12px", marginTop: "3px" }}>{question.localIndex + 1}.</div>
          // 				<div className="rdw-editor-question">
          // 					<CustomEditor editorState={tempQuestionState} />
          // 				</div>
          // 			</div>
          // 			{/* <div className="pl-2 pr-2 border border-primary rounded d-inline-block push-button">
          //                 <CheckBoxInline>
          //                     <CheckBox
          //                         key={i}
          //                         // onClick={(e) => makeRevise(e, i)}
          //                         checked={question.needToRevise || false}
          //                         checkBoxName="Mark for Review"
          //                         style={{ color: "#5458AF" }}
          //                     />
          //                 </CheckBoxInline>
          //             </div> */}
          // 		</h3>
          // 		<div>

          // 			<div className={`RichEditor-root px-0 parent-class ${tempAnswerStates.some(answer => answer.getCurrentContent().getPlainText().length > 100) ? "single-column" : ""}`}>
          // 				{tempAnswerStates.map((answer, j) => {


          // 					return (
          // 						<div className="row d-flex align-items-center child-class" key={j}>
          // 							<div className="col-md-2 col-2">
          // 								{question.answer_type_id === 'One' ? (
          // 									<RadioInline className="col-md-1">
          // 										<Radio
          // 											key={j}
          // 											// onChange={(e) => markOneAnswer(e, question.question_id, j)}
          // 											checked={question.answer && question.answer[0] === j}
          // 											style={{ color: "#5458AF" }}
          // 											value={j}
          // 										/>
          // 									</RadioInline>
          // 								) : (
          // 									<CheckBoxInline className="col-md-1">
          // 										<CheckBox
          // 											key={j}
          // 											// onClick={(e) => markAnswer(e, question.question_id, j)}
          // 											// checked={question.answer && question.answer.includes(j)}
          // 											checked={
          // 												question.answer &&
          // 												parseFloat(question.answer.split(",")[j]?.trim()) > 0
          // 											}
          // 											style={{ color: "#5458AF" }}
          // 										/>
          // 									</CheckBoxInline>
          // 								)}
          // 							</div>
          // 							<div className="col-md-10 col-10">
          // 								<CustomEditor editorState={answer} />

          // 								{/* <Editor
          //                                     editorState={answer}
          //                                     toolbarClassName="hide-toolbar"
          //                                     readOnly={true}
          //                                     toolbar={{}}
          //                                 /> */}
          // 							</div>
          // 						</div>
          // 					);
          // 				})}
          // 			</div>
          // 			<Divider />
          // 			<span style={{
          // 				color: '#2e7d32',
          // 				fontWeight: 600,
          // 				fontSize: '0.9rem',
          // 				backgroundColor: '#e8f5e9',
          // 				padding: '2px 8px',
          // 				borderRadius: '4px'
          // 			}}>
          // 				Allocated Marks: {question.mark_allocation || "0.0"}
          // 			</span>
          // 			<Typography variant="h6" gutterBottom>
          // 				<LiveHelpIcon />
          // 				<u> Marking Guidance</u>
          // 			</Typography>
          // 			<CustomEditor editorState={tempGuidenceState} />
          // 		</div>
          // 		<div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
          // 	</div>

          // );

        }
        else if (question?.question_type === questionTypeConstants.SUBMISSION.name) {

          let submissionList = [];
          let reload = false;
          if (question.answer && question.answer !== "[]") {
            submissionList = question.answer;
            reload = true;
          }

          // questionStates[question.question_id].tempAnswerStates = tempAnswerStates;

          // let viewSubmissions = submissionList?.map((attach, j) => {
          //     if (attach.replace(/"/g, "") !== "[]") {
          //         if (!question.filesUploaded?.includes(attach)) {
          //             return (
          //                 <div key={j}>
          //                     <QuestionButton
          //                         className="btn btn-outline-primary primary-button mr-2"
          //                         btnIconStyle="flaticon-interface-3"
          //                         inlineStyle={{ innerWidth: "400px" }}
          //                         btnName={"Remove file - " + attach.replace(/"/g, "")}
          //                         onClick={(e) => deleteSubmissionContent(attach, question.question_id)}
          //                     />
          //                 </div>
          //             );
          //         } else {
          //             return (
          //                 <div key={j}>
          //                     <QuestionButton
          //                         className="btn btn-outline-primary primary-button mr-2"
          //                         btnIconStyle="fa fa-spinner fa-spin"
          //                         inlineStyle={{ innerWidth: "400px" }}
          //                         btnName={"Uploading file - " + attach.replace(/"/g, "")}
          //                     />
          //                 </div>
          //             );
          //         }
          //     }
          //     return null;
          // });

          return (
            <div className="col-md-12" style={{ overflow: "auto" }} key={i}>
              <h3 className="mb-5 overflow-hidden all-questions-title">
                <div className="d-flex">
                  <div className="number-wrap" style={{ fontSize: "12px", marginTop: "3px" }}>{question.localIndex + 1}.</div>
                  <CustomEditor editorState={tempQuestionState} />
                </div>
                {/* <div className="pl-2 pr-2 border border-primary rounded d-inline-block push-button">
									<CheckBoxInline>
										<CheckBox
											key={i}
											// onClick={(e) => makeRevise(e, i)}
											checked={question.needToRevise || false}
											checkBoxName="Mark for Review"
											style={{ color: "#5458AF" }}
										/>
									</CheckBoxInline>
								</div> */}
              </h3>
              {/* <SubmissionFileUpload
								className="col-md-10 col-form-label"
								key={i}
								id={question.question_id}
								title={submissionList}
								defaultFile={submissionList}
								callBack={getSubmissionContent}
								deleteback={deleteSubmissionContent}
								reload={reload}
								questionIndex={question.question_id}
							/> */}
              <Divider />
              <span style={{
                color: '#2e7d32',
                fontWeight: 600,
                fontSize: '0.9rem',
                backgroundColor: '#e8f5e9',
                padding: '2px 8px',
                borderRadius: '4px'
              }}>
                Allocated Marks: {question.mark_allocation || "0.0"}
              </span>
              <Typography variant="h6" gutterBottom>
                <LiveHelpIcon />
                <u> Marking Guidance</u>
              </Typography>
              <CustomEditor editorState={tempGuidenceState} />
              <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
            </div>
          );
        }
        return null;
      });

      // setSubQuestions(subQuestions);
      // setFilteredQuestions(filteredQuestions);
      setQuestionStates(questionStates);
      setQuestionContent(question_content);
    }
  }, [assmnt_content, subQuestionsIndexes, questions, subQuestions]);

  useEffect(() => {

    if (assesment_review && assesment_review.length > 0) {

      const allReviewDetails = assesment_review.flatMap(item =>
        item.review_details.map(detail => ({
          ...detail,
          reviewer_name: item.teacher_name || null,
          status_name: item.status_name || ''
        }))
      );

      // const reviewCommentItems = assesment_review.filter(item => item.comment_type === 'MAIN' || item.comment_type === 'SUB');
      setComments(allReviewDetails)
      setMarkAsReview(allReviewDetails)
    }
  }, [assesment_review])

  useEffect(() => {

    if (assessment_operation && assessment_operation.length > 0) {

      const allOperationDetails = assessment_operation.flatMap(item =>
        item.operation_details.map(detail => ({
          ...detail,
          reviewer_name: item.teacher_name || null,
          status_name: item.status_name || ''
        }))
      );
      const IsOperationCompleted = assessment_operation[0]?.operation_completed
      setOperationComments(allOperationDetails)
      setOperationComplete(IsOperationCompleted)
    }
  }, [assessment_operation])

  useEffect(() => {

    if (assesment_review_state && assesment_review_state.success) {
      sweetStatusAlert("Success", assesment_review_state.message, "success")
      handlefetchAllMyAssessments()

    }
  }, [assesment_review_state])

  useEffect(() => {

    if (assesment_status_types && assesment_status_types.length > 0) {
      const filteredStatusOptions = assesment_status_types
        .filter((status) => status === "ReferBack" || status === "ReviewCompleted")
        .map((status) => ({
          key: status,
          value: statusDisplayMapping[status],
        }));
      setFilteredStatusOptions(filteredStatusOptions)
    }
  }, [assesment_status_types])

  useEffect(() => {

    if (finish_assesment_review && finish_assesment_review.success) {
      sweetStatusAlert(
        "Success",
        typeof finish_assesment_review.message === "string" ?
          finish_assesment_review.message
          :
          "Updated assessment and reviews",
        'success'
      )
      setIsFinishReviewModalOpen(false)
      setCurrentAssessmentId(null)
      setCurrentAssessmentStatusId(null)
      setOperationComplete(false)
      setCurrentAssessment(null)
      setIsModalOpen(false)
      setIsAssigned(false)
      handlefetchAllMyAssessments()
    }
    else if (finish_assesment_review && !finish_assesment_review.success) {
      sweetStatusAlert(
        "Failed",
        "Failed to update assessment and reviews",
        "error"
      )
    }
  }, [finish_assesment_review])

  useEffect(() => {

    if (finalize_paper && finalize_paper.success) {

      sweetStatusAlert(
        "Success",
        typeof finalize_paper.message === "string" ?
          finalize_paper.message
          :
          "Paper published successfully",
        'success'
      )
      setIsFinishReviewModalOpen(false)
      setCurrentAssessmentId(null)
      setCurrentAssessmentStatusId(null)
      setOperationComplete(false)
      setCurrentAssessment(null)
      setIsModalOpen(false)
      setIsAssigned(false)
      handlefetchAllMyAssessments()
    }
    else if (finalize_paper && !finalize_paper.success) {
      sweetStatusAlert(
        "Failed",
        "Failed to publish paper",
        "error"
      )
    }

  }, [finalize_paper])

  useEffect(() => {

    if (assesment_sub_review_state && assesment_sub_review_state.success) {
      setSubCommentModal(false)
      setSubComment("")
      sweetStatusAlert('Success', 'Comment added successfully', 'success')
      handleGetReviewComments(currentAssessmentId)
      handlefetchAllMyAssessments()
    }
    else if (assesment_sub_review_state && !assesment_sub_review_state.success) {
      sweetStatusAlert('Failed', 'Failed to add Comment', 'error')
    }

  }, [assesment_sub_review_state])

  useEffect(() => {

    if (assesment_mark_as_review_state && assesment_mark_as_review_state.success) {

      if (assesment_mark_as_review_state.data && assesment_mark_as_review_state.data.length > 0) {

        assesment_mark_as_review_state.data.map((reviewObj) => {

          let new_review_obj = {
            "asmnt_review_id": reviewObj.asmnt_review_id,
            "comment": reviewObj.comment,
            "created_at": reviewObj.created_at,
            "question_content_index": reviewObj.q_index,
            "question_id": reviewObj.question_id,
            "review_detail_id": reviewObj.review_detail_id,
            "mark_as_reviewed": reviewObj.reviewed,
            "updated_at": reviewObj.updated_at
          }

          setResReviewData(new_review_obj)
        })
      }
      // setResReviewData(assesment_mark_as_review_state.data[0])
      handlefetchAllMyAssessments()
      setSnackbar({
        open: true,
        message: 'Marked as review success',
        severity: 'success'
      });

    }
    else if (assesment_mark_as_review_state && !assesment_mark_as_review_state.success) {
      // setResReviewData(assesment_mark_as_review_state.data)
      setSnackbar({
        open: true,
        message: 'Marked as review failed',
        severity: 'error'
      });
    }

    function setResReviewData(reviewDataObj) {
      setMarkAsReview((prevmarkAsReview) => {
        const updatedMarkAsReview = prevmarkAsReview.map((item) => {

          if (item.question_id === reviewDataObj.question_id
            // && item.comment_type === "REVIEW"
          ) {
            return { ...item, ...reviewDataObj };
          }
          return item;
        });

        const isExist = updatedMarkAsReview.some(
          (item) => item.question_id === reviewDataObj.question_id
          // && item.comment_type === "REVIEW"
        );

        if (!isExist) {
          updatedMarkAsReview.push(reviewDataObj);
        }

        return updatedMarkAsReview;
      });
    }

  }, [assesment_mark_as_review_state])

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    // maxWidth: '800px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
  };

  const editQuestion = (content, questionId) => {

    const states = questionStates[questionId];
    setSelectedQuestionId(questionId)

    if (!states) {
      console.error("No states found for question", questionId);
      return;
    }
    setSelectedQuestion({
      isOpen: true,
      questionId: questionId,
      questionState: states.tempQuestionState || null,
      answerState: states.tempAnswerState || null,
      answerStates: states.tempAnswerStates || null,
      guidanceState: states.tempGuidenceState || null,
      subQuestions: states.subQuestions || null,
      type: states.type || null,
      answerTypeId: states.tempAnswerTypeId || null,
      mcqAnswer: states.tempMcqAnswer || null,
      mark_allocation: states.mark_allocation || 0.0
    });

  };


  return (
    <AdminTemplate>
      {/* //side bar ,footer */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={assmnt_loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div style={{ height: "auto", overflow: "visible" }}>
        <ContentWrapper>
          <Card>
            {/* papper title header name */}

            <CardHeader>
              <CardTitle cardLabel="Paper Review" />
            </CardHeader>

            <CardBody>

              {/* Top Controls Grid: Tabs, Search, Count (moved above filter) */}
              <div className="assessment-top-controls-grid">

                {/* 1. Paper Filter Nav Tabs */}
                {employeeType === "DEOP" && (
                  <div className="assessment-tabs-wrapper">
                    <TabList>
                      <NavItem
                        className={paperSwitchOptions?.value === paperFilterOptions[0].value ? "nav-link active" : "nav-link"}
                        id="my-papers-tab"
                        href="#my-papers"
                        dataToggle="tab"
                        tabName="My Papers"
                        onClick={() => setPaperSwitchOptions(paperFilterOptions[0])}
                      />
                      <NavItem
                        className={paperSwitchOptions?.value === paperFilterOptions[1].value ? "nav-link active" : "nav-link"}
                        id="all-papers-tab"
                        href="#all-papers"
                        dataToggle="tab"
                        tabName="All Papers"
                        onClick={() => setPaperSwitchOptions(paperFilterOptions[1])}
                      />
                    </TabList>
                  </div>
                )}

                {/* 2. Search Field */}
                <div className="assessment-search-wrapper">
                  <Form.Group controlId="exampleForm.ControlInput1" className="mb-0">
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      onChange={handleSearch}
                      className="w-100"
                    />
                  </Form.Group>
                </div>

                {/* 3. Number of Papers */}
                <div className="assessment-count-wrapper">
                  <div className="sort-button no-of-papers" style={{ fontSize: '0.9rem', fontFamily: 'Inter, sans-serif' }}>
                    <span className="sort-by-label">No of Papers</span>
                    <span className="sort-current" style={{ marginLeft: '8px', marginRight: '8px', fontWeight: 600, color: '#e49424', fontFamily: 'Inter, sans-serif' }}>
                      {state.isTableDataLoading ? (
                        <CircularProgress size={16} />
                      ) : (
                        totalCount
                      )}
                    </span>
                  </div>
                </div>

              </div>

              <div className="col-md-12 px-0 filterBySec">
                <PaperFilterLayout
                  userType={employeeType}
                  onFilterChange={handleFilterChange}
                  filterKeys={employeeType == "DEOP" ? EMPLOYEE_FILTERS.DEOP.AssessmentReview : EMPLOYEE_FILTERS.TEACH}
                  isShowExamStatus={false}
                />
              </div>

              <div className="thepapers-wrapper">
                <div className="col-md-12 px-0">
                  <div className="row mt-6">
                    <div className="col-md-12 px-0">

                      <StickyCardBody>
                      </StickyCardBody>

                      <div className="review-cards-container">
                        {myAssessments &&
                          myAssessments.length > 0 &&
                          !loading ? (
                          myAssessments.map((assessment, index) => (
                            <div key={`review-card-${assessment.assessment_id}`} className="review-paper-card">
                              <div className="review-card-content">
                                {/* Left Section - Paper Code & Title */}
                                <div className="review-left-section">
                                  <div className="review-card-title-row">
                                    <span className="review-card-code">
                                      {"ASMNT" + assessment.assessment_id}
                                    </span>
                                    <Tooltip
                                      title={assessment.title}
                                      placement="bottom-start"
                                      arrow
                                    >
                                      <span className="review-card-title">
                                        {assessment.title}
                                      </span>
                                    </Tooltip>
                                  </div>
                                </div>

                                {/* Right Section - Assigned To, Status & Actions */}
                                <div className="review-right-section">
                                  {/* Assigned To */}
                                  <div className="review-assigned-section">
                                    <span className="review-assigned-label">Assigned to</span>
                                    <span className="review-assigned-name">
                                      {(assessment.status_id ===
                                        assessmentStatusConstants.PROOFREADING.id ||
                                        assessment.status_id ===
                                        assessmentStatusConstants.DATAENTRYVERIFICATION.id
                                        ? assessment.review_state?.find(
                                          (r) => r.is_operation_latest === true
                                        )?.teacher_name
                                        : assessment.review_state?.find(
                                          (r) => r.is_latest === true
                                        )?.teacher_name) || "N/A"}
                                    </span>
                                  </div>

                                  {/* Status Section - main status and substatus as separate chips */}
                                  <div className="review-status-section">
                                    <span className={getStatusClass(assessment.assessment_state)}>
                                      <span className="ph-status-main">{assessment.assessment_state}</span>
                                    </span>

                                    {/* substatus rendered as its own chip next to the main status */}
                                    {assessment?.assessment_state === "Review" ? (
                                      assessment.review_state?.some(
                                        (r) => "asmnt_review_id" in r && r.is_follow_up === true
                                      ) ? (
                                        <span className="ph-paper-status ph-status-sub followup">Follow up</span>
                                      ) : (
                                        <span className="ph-paper-status ph-status-sub initial">Initial</span>
                                      )
                                    ) : (
                                      (assessment?.status_id === assessmentStatusConstants.PROOFREADING.id ||
                                        assessment?.status_id === assessmentStatusConstants.DATAENTRYVERIFICATION.id) && (
                                        <span
                                          className={`ph-paper-status ph-status-sub ${assessment.review_state?.find(r => r.is_operation_latest === true)?.operation_completed ? 'completed' : 'inprogress'}`}
                                        >
                                          {assessment.review_state?.find(r => r.is_operation_latest === true)?.operation_completed ? 'Completed' : 'InProgress'}
                                        </span>
                                      )
                                    )}
                                  </div>

                                  {/* Actions */}
                                  <div className="review-actions-group">
                                    <Tooltip title="View Details" placement="top" arrow>
                                      <button
                                        className="review-action-btn view-btn flaticon-eye-icon"
                                        onClick={() =>
                                          handleClickGetAssesmentContent(assessment)
                                        }
                                        disabled={assignment_background_loading}
                                      />
                                    </Tooltip>
                                    {employeeType === "MASAD" && (
                                      <>
                                        <Tooltip title="Assign employee for operation" placement="top" arrow>
                                          <button
                                            className="review-action-btn assign-btn"
                                            onClick={() => handleReviewModal(assessment)}
                                            disabled={assignment_background_loading}
                                          >
                                            <PersonIcon style={{ fontSize: '1.2rem' }} />
                                          </button>
                                        </Tooltip>
                                        {assessment?.assessment_state === assessmentStatusConstants.REFERBACK.name && 
                                          <Tooltip title="Update Status" placement="top" arrow>
                                            <button
                                              className="review-action-btn update-btn"
                                              onClick={() => {
                                                setSelectedAssessment(assessment);
                                                handleOpenAssessmentStatusDialog();
                                              }}
                                              disabled={assignment_background_loading}
                                            >
                                              <EditIcon style={{ fontSize: "1.2rem" }} />
                                            </button>
                                          </Tooltip>
                                        }
                                        {(assessment?.assessment_state !== assessmentStatusConstants.READY.name && assessment?.assessment_state !== assessmentStatusConstants.PROOFREADING.name) && 
                                          <Tooltip title="Reset Review" placement="top" arrow>
                                            <button
                                              className="review-action-btn reset-btn"
                                              onClick={() => {
                                                setSelectedAssessment(assessment);

                                                sweetStatusAlert(
                                                  "Confirm",
                                                  "Are you sure you want to clear all review details and reset this assessment?",
                                                  "warning"
                                                ).then((confirm) => {
                                                  if (confirm) {
                                                    handleResetAssessmentReview();
                                                  }
                                                });
                                              }}
                                              disabled={assignment_background_loading}
                                            >
                                              <RestartAltIcon style={{ fontSize: "1.2rem" }} />
                                            </button>
                                          </Tooltip>
                                        }
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : loading ? (
                          <>
                            <div className="review-skeleton-card">
                              <Skeleton height={30} />
                              <Skeleton animation="wave" height={30} />
                            </div>
                            <div className="review-skeleton-card">
                              <Skeleton height={30} />
                              <Skeleton animation="wave" height={30} />
                            </div>
                            <div className="review-skeleton-card">
                              <Skeleton height={30} />
                              <Skeleton animation="wave" height={30} />
                            </div>
                          </>
                        ) : (
                          <div className="no-papers-container">
                            <div className="no-papers-inner">
                              <i className="fas fa-inbox no-papers-icon" aria-hidden="true"></i>
                              <span className="no-papers-text">No Papers Available!</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-end">
                <MaterialCustomTablePagination
                  totalCount={totalCount}
                  currentPage={currentPage}
                  limit={rowsPerPage}
                  handlePageChange={handlePageChange}
                  handleRowsPerPageChange={handleRowsPerPageChange}
                  handlePageOffsetChange={handlePageOffsetChange}
                  offset={state.offset}
                  rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
                />
              </div>

            </CardBody>

          </Card>

        </ContentWrapper>
      </div>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: 'right' }}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Modal
        open={reviewerModal}
        onClose={() => handleReviewModal(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, width: 400, mx: 'auto', mt: '20vh' }}>
          <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={add_review_loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          {/* Assessment Details */}
          {selectedAssessment && (
            <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
              <Typography variant="h6" gutterBottom>Paper Details</Typography>
              <Typography variant="body2" sx={{ mb: 3 }}><strong>Title : </strong> {selectedAssessment?.title || "N/A"} </Typography>
              <Typography variant="body2" sx={{ mb: 3 }}>
                <strong>Operation Status: </strong>
                {selectedAssessment?.assessment_state || "N/A"}
                {" "}
                {selectedAssessment?.status_id === assessmentStatusConstants.PROOFREADING.id ? (selectedAssessment?.status_id === assessmentStatusConstants.PROOFREADING.id
                  && selectedAssessment.review_state?.find(r => r.is_operation_latest === true)?.operation_completed ? "Completed" : "InProgress") : ""}
              </Typography>
              <Typography variant="body2" sx={{ mb: 3 }}>
                <strong>Assigned Employee : </strong>
                {((selectedAssessment?.status_id === assessmentStatusConstants.PROOFREADING.id || selectedAssessment?.status_id === assessmentStatusConstants.DATAENTRYVERIFICATION.id)
                  ? selectedAssessment.review_state?.find(r => r.is_operation_latest === true)?.teacher_name : selectedAssessment.review_state?.find(r => r.is_latest === true)?.teacher_name) || "N/A"}
              </Typography>
              <Typography variant="body2" sx={{ mb: 3 }}>
                <strong>Assigned By : </strong>
                {((selectedAssessment?.status_id === assessmentStatusConstants.PROOFREADING.id || selectedAssessment?.status_id === assessmentStatusConstants.DATAENTRYVERIFICATION.id)
                  ? selectedAssessment.review_state?.find(r => r.is_operation_latest === true)?.assigned_by_name : selectedAssessment.review_state?.find(r => r.is_latest === true)?.assigned_by_name) || "N/A"}
              </Typography>
              <Typography variant="body2" sx={{ mb: 3 }}><strong>Created By : </strong> {selectedAssessment?.first_name} {selectedAssessment?.last_name || "N/A"}</Typography>
              <Typography variant="body2" sx={{ mb: 3 }}><strong>Created At : </strong> {getCreatedAtLocal(selectedAssessment?.created_at) || "N/A"}</Typography>
            </Box>
          )}


          <Box display="flex" flexDirection="column" gap={3}>
            <Autocomplete
              options={assessmentStatusesList}
              getOptionLabel={(option) => option.status || ''}
              value={assessmentStatusesList.find((item) => item.status_id === selectedOperation) || null}
              onChange={(event, newValue) => {
                setSelectedOperation(newValue ? newValue.status_id : null);
              }}
              loading={operationLoading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Operation"
                  placeholder="Type to search..."
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {operationLoading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              disabled={operationLoading}
              isOptionEqualToValue={(option, value) => option.status_id === value.status_id}
            />

            <Autocomplete
              options={reviewersList}
              getOptionLabel={(option) =>
                `${option.user_code} - ${option.first_name} ${option.last_name}`
              }
              value={reviewersList.find((item) => item.user_id === selectedReviewer) || null}
              onChange={(event, newValue) => {
                setSelectedReviewer(newValue ? newValue.user_id : null);
              }}
              loading={reviewerLoading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Employee"
                  placeholder="Type to search..."
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {reviewerLoading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              disabled={reviewerLoading || operationLoading}
              isOptionEqualToValue={(option, value) => option.user_id === value.user_id}
            />
          </Box>

          {/* Action Buttons */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
            <Button
              onClick={selectedOperation === assessmentStatusConstants.REVIEW.id ? handleAssignReviewer : handleAssignOperator}
              variant="contained"
              color="primary"
            >
              Assign
            </Button>
            {/* <Button
              onClick={selectedOperation === assessmentStatusConstants.REVIEW.id ? handleChangeAssignedReviewer : handleChangeAssignedOperator}
              disabled={selectedAssessmentOperationId === null}
              variant="contained"
              color="primary"
            >
              Update
            </Button> */}
            <Button onClick={() => handleReviewModal(null)} variant="contained" color="secondary">
              Close
            </Button>
          </div>
        </Box>
      </Modal>


      <Modal
        open={subCommentModal}
        onClose={handleSubCommentModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >


        <Box sx={subCommentModalStyle}>
          <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={sub_review_loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <TextField
            id="standard-multiline-static"
            label="Add Comment"
            multiline
            fullWidth
            rows={4}
            value={subComment}
            onChange={(e) => setSubComment(e.target.value)}
            placeholder="Type your comment here..."
            variant="standard"
          />

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>

            <Button onClick={currentAssessmentStatusId === assessmentStatusConstants.PROOFREADING.id ? handleSaveSubOperationComment : handleSaveSubReviewComment} variant="contained" color="primary">
              Add Comment
            </Button>
            <Button onClick={handleSubCommentModal} variant="contained" color="secondary">
              Close
            </Button>
          </div>

        </Box>
      </Modal>

      <Modal
        open={isModalOpen && currentAssessmentId}
        onClose={async () => {
          if (isChanged) {
            try {
              const confirmClose = await sweetAlert(
                "Are you sure?",
                "You want to close before saving!",
                "warning"
              );
              if (confirmClose === false) {
                setIsModalOpen(false);
                setIsAssigned(false)
                // setIsChanged(false);
                setIsFinishReviewModalOpen(false)
                setCurrentAssessmentId(null)
                setCurrentAssessmentStatusId(null)
                setOperationComplete(false)
                setCurrentAssessment(null)
                validator.hideMessages()
                validator.purgeFields()

              }
            } catch (error) {
              console.error("Error while confirming close:", error);
            }
          } else {
            setIsModalOpen(false);
            setIsAssigned(false)
            // setIsChanged(false);
            setIsFinishReviewModalOpen(false)
            setCurrentAssessmentId(null)
            setCurrentAssessmentStatusId(null)
            setOperationComplete(false)
            setCurrentAssessment(null)
            validator.hideMessages()
            validator.purgeFields()
          }
        }}
        aria-labelledby="question-modal-title"
        aria-describedby="question-modal-description"
      >

        <Box sx={modalStyle}>
          <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={review_loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          <Typography id="question-modal-title" variant="h6" component="h2">
            Questions
          </Typography>

          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Paper Status:{" "}
            {myAssessments?.map((assessment, index) =>
              currentAssessmentId === assessment?.assessment_id ? (
                <span key={index} className={getColor(assessment?.assessment_state)}>
                  {assessment?.assessment_state}
                </span>
              ) : null
            )}
            {" "}
            {
              (currentAssessmentStatusId === assessmentStatusConstants.PROOFREADING.id || currentAssessmentStatusId === assessmentStatusConstants.DATAENTRYVERIFICATION.id)
                ?
                <span className={operationComplete ? "label label-lg label-success label-inline" : "label label-lg label-light-primary label-inline"}>
                  {operationComplete ? "Completed" : "InProgress"}
                </span>
                : ""
            }
          </Typography>

          {currentAssessmentStatusId === assessmentStatusConstants.PROOFREADING.id || currentAssessmentStatusId === assessmentStatusConstants.DATAENTRYVERIFICATION.id
            ?
            /*ProofRead/DataEntryVerification Operation*/
            (assessment_parts.length === 0 ?
              <Typography id="question-modal-description" sx={{ mt: 2 }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <div
                    ref={containerRef}
                    style={{
                      flex: 2,
                      overflowY: 'scroll',
                      maxHeight: '500px',
                      border: '1px solid #eee',
                      borderRadius: '8px',
                      padding: '10px',
                    }}
                  >
                    {questionContent?.length > 0 ? (
                      questionContent.map((content, i) => {

                        const questionId = questions[i]?.question_id;

                        return (
                          <div
                            key={i}
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: '10px',
                              marginBottom: '20px',
                              padding: 5,
                            }}
                          >
                            <div
                              className={`question-item mb-5 ${'highlighted'}`}
                              ref={questionRefs[i]}
                              style={{ flex: 1 }}
                            >
                              {content}
                            </div>
                            {currentAssessment?.assessment_state === assessmentStatusConstants.PROOFREADING.name && operationComplete === false &&
                              <Fab
                                onClick={() => editQuestion(content, questionId)}
                                variant="extended" size="small" color="primary" sx={{ mt: 1 }}>

                                <EditIcon sx={{ mr: 1 }} />
                                Edit Question
                              </Fab>
                            }
                          </div>
                        )
                      })
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                        Paper does not contain any questions.
                      </div>
                    )}
                  </div>

                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
                    <Backdrop
                      sx={(theme) => ({
                        color: '#fff',
                        zIndex: theme.zIndex.drawer + 1,
                        position: 'absolute',
                        borderRadius: '4px',
                      })}
                      open={operation_comment_loading}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>

                    <Step>
                      <List
                        style={{
                          flex: 1,
                          maxHeight: '400px',
                          overflowY: 'auto',
                          padding: '10px',
                          border: '1px dotted #ddd',
                          borderRadius: '5px',
                          marginBottom: '10px',
                        }}
                      >
                        {operationComments?.filter((c) => c.comment?.trim() !== '').length > 0 ? (
                          operationComments
                            .filter((c) => c.comment?.trim() !== '')
                            .map((subcomment, index) => (
                              <ListItem key={index}>
                                <ListItemAvatar>
                                  <Avatar>
                                    <ThreePTwoToneIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={subcomment.comment}
                                  secondary={
                                    <>
                                      <Typography component="span" variant="body2" style={{ fontStyle: "italic" }}>
                                        @ {subcomment?.reviewer_name || "N/A"}
                                      </Typography>
                                      <br />
                                      <Typography component="span" variant="caption" style={{ color: "#666" }}>
                                        {TimeZoneHandler.formattedTimeString(subcomment?.created_at)}

                                      </Typography>
                                    </>
                                  }
                                />
                              </ListItem>
                            ))
                        ) : (
                          <Typography
                            variant="body2"
                            style={{ padding: '10px', textAlign: 'center', color: '#888' }}
                          >
                            No comments for paper yet
                          </Typography>
                        )}
                      </List>
                    </Step>

                    {isAssigned && operationComplete === false && (
                      <Fab
                        disabled={myAssessments?.some(
                          (assessment) =>
                            currentAssessmentId === assessment?.assessment_id &&
                            assessment?.assessment_state === 'ReferBack'
                        )}
                        onClick={() => handleSubCommentModal()}
                        variant="extended"
                        size="small"
                        color="primary"
                        sx={{ mt: 1, alignSelf: 'flex-start' }}
                      >
                        <AddIcon sx={{ mr: 1 }} />
                        Add Comment for Paper
                      </Fab>

                    )}
                  </div>
                </div>
              </Typography>
              :
              <Typography id="question-modal-description" sx={{ mt: 2 }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <div
                    ref={containerRef}
                    style={{
                      flex: 2,
                      overflowY: 'scroll',
                      maxHeight: '500px',
                      border: '1px solid #eee',
                      borderRadius: '8px',
                      padding: '10px',
                    }}
                  >
                    {questionContent?.length > 0 ? (
                      <>
                        <AssessmentInfoCard details={assessmentDetails} />
                        {assessment_parts.sort((a, b) => a.display_order - b.display_order)?.map((part) => (
                          <div
                            key={`part-${part.part_id}`}
                            style={{
                              marginBottom: '30px',
                              backgroundColor: '#fcf6ff',
                              padding: '15px',
                              borderRadius: '4px',
                            }}
                          >
                            <Typography variant="h5" gutterBottom>
                              {part.part_title}
                            </Typography>

                            {part.allow_instruction && part.part_instruction?.trim() && (
                              <div style={{ marginBottom: '10px' }}>
                                <ul style={{ paddingLeft: '20px', margin: 0 }}>
                                  {part.part_instruction
                                    .split(/\n|•|\*/g)
                                    .map(line => line.trim())
                                    .filter(line => line.length > 0)
                                    .map((line, idx) => (
                                      <li key={idx} style={{ marginBottom: '5px' }}>
                                        {line}
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            )}

                            {assessment_sections
                              ?.filter((section) => section.assessment_part_id === part.assessment_part_id)
                              .sort((a, b) => a.display_order - b.display_order)
                              .map((section) => {
                                const sectionQuestions = questions
                                  .filter((q) => q.section_id === section.part_section_id)
                                  .map((q) => {
                                    const index = questions.findIndex((qq) => qq.question_id === q.question_id);
                                    return {
                                      ...q,
                                      content: questionContent[index],
                                      index: index,
                                    };
                                  });

                                if (sectionQuestions.length === 0) return null;

                                return (
                                  <div
                                    key={`section-${section.part_section_id}`}
                                    style={{
                                      marginBottom: '20px',
                                      backgroundColor: '#FFF6ED',
                                      padding: '15px',
                                      borderRadius: '4px',
                                    }}
                                  >
                                    <Typography variant="h6" gutterBottom>
                                      {section.section_title}
                                    </Typography>

                                    {section.allow_instruction && section.section_instruction?.trim() && (
                                      <div style={{ marginBottom: '10px' }}>
                                        <ul style={{ paddingLeft: '20px', margin: 0 }}>
                                          {section.section_instruction
                                            .split(/\n|•|\*/g)
                                            .map(line => line.trim())
                                            .filter(line => line.length > 0)
                                            .map((line, idx) => (
                                              <li key={idx} style={{ marginBottom: '5px' }}>
                                                {line}
                                              </li>
                                            ))}
                                        </ul>
                                      </div>
                                    )}

                                    {sectionQuestions.map((question, i) => (
                                      <div
                                        key={`q-${question.question_id}`}
                                        style={{
                                          display: 'flex',
                                          alignItems: 'flex-start',
                                          gap: '10px',
                                          marginBottom: '20px',
                                          padding: '5px',
                                        }}
                                      >
                                        <div
                                          className="question-item mb-5 highlighted"
                                          ref={questionRefs[question.index]}
                                          style={{ flex: 1, display: 'flex', gap: '8px' }}
                                        >
                                          {question.content}
                                        </div>

                                        {currentAssessment?.assessment_state ===
                                          assessmentStatusConstants.PROOFREADING.name &&
                                          !operationComplete && (
                                            <Fab
                                              onClick={() =>
                                                editQuestion(
                                                  question.content,
                                                  question.question_id
                                                )
                                              }
                                              variant="extended"
                                              size="small"
                                              color="primary"
                                              sx={{ mt: 1 }}
                                            >
                                              <EditIcon sx={{ mr: 1 }} />
                                              Edit Question
                                            </Fab>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                );
                              })}
                          </div>
                        ))}
                      </>
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                        Paper does not contain any questions.
                      </div>
                    )}
                  </div>

                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
                    <Backdrop
                      sx={(theme) => ({
                        color: '#fff',
                        zIndex: theme.zIndex.drawer + 1,
                        position: 'absolute',
                        borderRadius: '4px',
                      })}
                      open={operation_comment_loading}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>

                    <Step>
                      <List
                        style={{
                          flex: 1,
                          maxHeight: '400px',
                          overflowY: 'auto',
                          padding: '10px',
                          border: '1px dotted #ddd',
                          borderRadius: '5px',
                          marginBottom: '10px',
                        }}
                      >
                        {operationComments?.filter((c) => c.comment?.trim() !== '').length > 0 ? (
                          operationComments
                            .filter((c) => c.comment?.trim() !== '')
                            .map((subcomment, index) => (
                              <ListItem key={index}>
                                <ListItemAvatar>
                                  <Avatar>
                                    <ThreePTwoToneIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={subcomment.comment}
                                  secondary={
                                    <>
                                      <Typography component="span" variant="body2" style={{ fontStyle: "italic" }}>
                                        @ {subcomment?.reviewer_name || "N/A"}
                                      </Typography>
                                      <br />
                                      <Typography component="span" variant="caption" style={{ color: "#666" }}>
                                        {TimeZoneHandler.formattedTimeString(subcomment?.created_at)}

                                      </Typography>
                                    </>
                                  }
                                />
                              </ListItem>
                            ))
                        ) : (
                          <Typography
                            variant="body2"
                            style={{ padding: '10px', textAlign: 'center', color: '#888' }}
                          >
                            No comments for paper yet
                          </Typography>
                        )}
                      </List>
                    </Step>

                    {isAssigned && operationComplete === false && (
                      <Fab
                        disabled={myAssessments?.some(
                          (assessment) =>
                            currentAssessmentId === assessment?.assessment_id &&
                            assessment?.assessment_state === 'ReferBack'
                        )}
                        onClick={() => handleSubCommentModal()}
                        variant="extended"
                        size="small"
                        color="primary"
                        sx={{ mt: 1, alignSelf: 'flex-start' }}
                      >
                        <AddIcon sx={{ mr: 1 }} />
                        Add Comment for Paper
                      </Fab>

                    )}
                  </div>
                </div>
              </Typography>
            )
            /*Review Operation*/
            :

            (assessment_parts.length === 0 ?

              <Typography id="question-modal-description" sx={{ mt: 2 }}>

                <div ref={containerRef} style={{ overflowY: 'scroll', height: '500px' }}>
                  {questionContent?.length > 0 ? (
                    questionContent.map((content, i) => {

                      const questionId = questions[i]?.question_id;
                      // const markasreviewed = comments?.find((c) => c.question_id === questionId && c.comment_type === 'REVIEW')?.comment || '';
                      const markasreviewed = markAsReview?.find(
                        (c) => c.question_id === questionId
                        // && (c.status_name === "InReview" || c.status_name === "ReviewCompleted" || c.status_name === "Published")
                        // && c.comment_type === "REVIEW"
                      )?.mark_as_reviewed;

                      const filteredComments = markAsReview?.filter(
                        (c) => c.question_id === questionId
                        // && (c.comment_type === "MAIN" || c.comment_type === "SUB")
                      );


                      return (
                        <div
                          key={i}
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '10px',
                            marginBottom: '20px',
                            padding: 5,
                          }}
                        >
                          <div
                            className={`question-item mb-5 ${'highlighted'}`}
                            ref={questionRefs[i]}
                            style={{ flex: '7' }}
                          >
                            {content}
                          </div>

                          <div style={{ flex: '3', position: 'relative' }}>

                            <Backdrop
                              sx={(theme) => ({
                                color: '#fff',
                                zIndex: theme.zIndex.drawer + 1,
                                position: 'absolute',
                                borderRadius: '4px',
                              })}
                              open={comment_loading}
                            >
                              <CircularProgress color="inherit" />
                            </Backdrop>
                            {(employeeType !== "DEOP" && employeeType !== "MASAD") &&
                              <FormControlLabel
                                value="end"
                                // disabled={employeeType === "MASAD" ? false : markasreviewed === 1 || markasreviewed === true ? true : isAssigned ? false : true}
                                disabled={
                                  myAssessments?.some(
                                    (assessment) =>
                                      currentAssessmentId === assessment?.assessment_id &&
                                      assessment?.assessment_state === 'ReferBack'
                                  ) || (
                                    employeeType !== "MASAD" &&
                                    ((markasreviewed === 1 || markasreviewed === true)
                                      ? true
                                      : isAssigned
                                        ? false
                                        : true)
                                  )
                                }
                                control={
                                  loadingStates[questionId] ? (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10 }}>
                                      <CircularProgress size={16} />
                                    </div>
                                  ) : (
                                    <BpCheckbox checked={markasreviewed === 1 || markasreviewed === true ? true : false} onChange={(e) => handleMarkAsReviewChange(i, e.target.checked ? 1 : 0, questionId)} />
                                  )
                                }
                                label={markasreviewed === 1 || markasreviewed === true ? "Marked as Reviewed" : "Mark as Reviewed"}
                                labelPlacement="end"
                              />
                            }

                            <Step key={i}>

                              <List style={{ maxHeight: "150px", overflow: "auto", padding: "5px", border: "1px dotted #ddd", borderRadius: "5px" }}>

                                {filteredComments?.filter((subcomment) => subcomment.comment?.trim() !== "").length > 0 ? (
                                  filteredComments
                                    .filter((subcomment) => subcomment.comment?.trim() !== "")
                                    .map((subcomment, index) => {
                                      const commentText = subcomment.comment;
                                      return (
                                        <ListItem key={index}>
                                          <ListItemAvatar>
                                            <Avatar>
                                              <ThreePTwoToneIcon />
                                            </Avatar>
                                          </ListItemAvatar>
                                          <ListItemText
                                            primary={commentText}
                                            secondary={
                                              <>
                                                <Typography component="span" variant="body2" style={{ fontStyle: "italic" }}>
                                                  @ {subcomment?.reviewer_name || "N/A"}
                                                </Typography>
                                                <br />
                                                <Typography component="span" variant="caption" style={{ color: "#666" }}>
                                                  {TimeZoneHandler.formattedTimeString(subcomment?.created_at)}

                                                </Typography>
                                              </>
                                            }
                                          />
                                        </ListItem>
                                      );
                                    })
                                ) : (
                                  <Typography variant="body2" style={{ padding: "10px", textAlign: "center", color: "#888" }}>
                                    No comments yet
                                  </Typography>
                                )}
                              </List>

                            </Step>
                            {
                              // (employeeType !== "DEOP" && employeeType !== "MASAD")
                              isAssigned
                              && markasreviewed !== true &&
                              <Fab
                                disabled={myAssessments?.some(
                                  (assessment) =>
                                    currentAssessmentId === assessment?.assessment_id &&
                                    assessment?.assessment_state === 'ReferBack'
                                )}
                                onClick={() => handleSubCommentModal(i, questionId)}
                                variant="extended" size="small" color="primary" sx={{ mt: 1 }}>

                                <AddIcon sx={{ mr: 1 }} />
                                Add Comment
                              </Fab>

                            }
                            {/* {currentAssessmentStatusId === assessmentStatusConstants.ReviewCompleted.id && employeeType === "DEOP" &&
													<Fab
														disabled={myAssessments?.some(
															(assessment) =>
																currentAssessmentId === assessment?.assessment_id &&
																assessment?.assessment_state === 'ReferBack'
														)}
														 onClick={() => handleSubCommentModal(i, questionId)} 
														 variant="extended" size="small" color="primary" sx={{ mt: 1 }}>

														<AddIcon sx={{ mr: 1 }} />
														Add Comment
													</Fab>
												} */}
                            {(employeeType === "MASAD" || employeeType === "DEOP" || employeeType === "TEACH") &&
                              (currentAssessment?.assessment_state === assessmentStatusConstants.REFERBACK.name || currentAssessment?.assessment_state === assessmentStatusConstants.INREVIEW.name || currentAssessment?.assessment_state === assessmentStatusConstants.REVIEW.name) &&
                              <Fab
                                onClick={() => editQuestion(content, questionId)}
                                variant="extended" size="small" color="primary" sx={{ mt: 1 }}>

                                <EditIcon sx={{ mr: 1 }} />
                                Edit Question
                              </Fab>
                            }



                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                      Paper does not contain any questions.
                    </div>
                  )}
                  {employeeType !== "TEACH" &&
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '10px',
                        marginBottom: '20px',
                        padding: 5,
                      }}
                    >
                      <Backdrop
                        sx={(theme) => ({
                          color: '#fff',
                          zIndex: theme.zIndex.drawer + 1,
                          position: 'absolute',
                          borderRadius: '4px',
                        })}
                        open={operation_comment_loading}
                      >
                        <CircularProgress color="inherit" />
                      </Backdrop>
                      <Step>
                        <h6>ProofReading Comments for Paper</h6>
                        <List
                          style={{
                            flex: 1,
                            maxHeight: '400px',
                            overflowY: 'auto',
                            padding: '10px',
                            border: '1px dotted #ddd',
                            borderRadius: '5px',
                            marginBottom: '10px',
                          }}
                        >
                          {operationComments?.filter((c) => c.comment?.trim() !== '').length > 0 ? (
                            operationComments
                              .filter((c) => c.comment?.trim() !== '')
                              .map((subcomment, index) => (
                                <ListItem key={index}>
                                  <ListItemAvatar>
                                    <Avatar>
                                      <ThreePTwoToneIcon />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={subcomment.comment}
                                    secondary={
                                      <>
                                        <Typography component="span" variant="body2" style={{ fontStyle: "italic" }}>
                                          @ {subcomment?.reviewer_name || "N/A"}
                                        </Typography>
                                        <br />
                                        <Typography component="span" variant="caption" style={{ color: "#666" }}>
                                          {TimeZoneHandler.formattedTimeString(subcomment?.created_at)}

                                        </Typography>
                                      </>
                                    }
                                  />
                                </ListItem>
                              ))
                          ) : (
                            <Typography
                              variant="body2"
                              style={{ padding: '10px', textAlign: 'center', color: '#888' }}
                            >
                              No proofreading comments for paper yet
                            </Typography>
                          )}
                        </List>
                      </Step>
                    </div>
                  }
                </div>
              </Typography>

              :

              // <Typography id="question-modal-description" sx={{ mt: 2 }}>
              // 	<div ref={containerRef} style={{ overflowY: 'scroll', height: '500px' }}>
              // 		{questionContent?.length > 0 ? (

              // 		Object.entries(
              // 			questions.reduce((acc, question, i) => {
              // 			const partId = question.part_id;
              // 			if (!acc[partId]) {
              // 				acc[partId] = {
              // 				partName: question.part_name,
              // 				questions: []
              // 				};
              // 			}
              // 			acc[partId].questions.push({
              // 				...question,
              // 				content: questionContent[i],
              // 				index: i
              // 			});
              // 			return acc;
              // 			}, {})
              // 		).map(([partId, partData]) => (
              // 			<div key={`part-${partId}`} style={{ marginBottom: '30px', backgroundColor:'GrayText' }}>
              // 			<Typography variant="h5" gutterBottom>
              // 				Part {partData.partName}
              // 			</Typography>


              // 			{Object.entries(
              // 				partData.questions.reduce((acc, question) => {
              // 				const sectionId = question.section_id;
              // 				if (!acc[sectionId]) {
              // 					acc[sectionId] = {
              // 					sectionName: question.section_name,
              // 					sectionTitle: question.section_title,
              // 					questions: []
              // 					};
              // 				}
              // 				acc[sectionId].questions.push(question);
              // 				return acc;
              // 				}, {})
              // 			).map(([sectionId, sectionData]) => (
              // 				<div key={`section-${sectionId}`} style={{ marginBottom: '20px', backgroundColor:'Highlight' }}>
              // 				<Typography variant="h6" gutterBottom>
              // 					{sectionData.sectionName}: {sectionData.sectionTitle}
              // 				</Typography>


              // 				{sectionData.questions.map((question, i) => {
              // 					const questionId = question.question_id;
              // 					const markasreviewed = markAsReview?.find(
              // 					(c) => c.question_id === questionId
              // 					)?.mark_as_reviewed;

              // 					const filteredComments = markAsReview?.filter(
              // 					(c) => c.question_id === questionId
              // 					);

              // 					return (
              // 					<div
              // 						key={i}
              // 						style={{
              // 						display: 'flex',
              // 						alignItems: 'flex-start',
              // 						gap: '10px',
              // 						marginBottom: '20px',
              // 						padding: 5,
              // 						}}
              // 					>
              // 						<div
              // 						className={`question-item mb-5 ${'highlighted'}`}
              // 						ref={questionRefs[question.index]}
              // 						style={{ flex: '7' }}
              // 						>
              // 						{question.content}
              // 						</div>

              // 						<div style={{ flex: '3', position: 'relative' }}>
              // 						<Backdrop
              // 							sx={(theme) => ({
              // 							color: '#fff',
              // 							zIndex: theme.zIndex.drawer + 1,
              // 							position: 'absolute',
              // 							borderRadius: '4px',
              // 							})}
              // 							open={comment_loading}
              // 						>
              // 							<CircularProgress color="inherit" />
              // 						</Backdrop>
              // 						{(employeeType !== "DEOP" &&  employeeType !== "MASAD") &&
              // 							<FormControlLabel
              // 							value="end"
              // 							disabled={
              // 								myAssessments?.some(
              // 								(assessment) =>
              // 									currentAssessmentId === assessment?.assessment_id &&
              // 									assessment?.assessment_state === 'ReferBack'
              // 								) || (
              // 								employeeType !== "MASAD" &&
              // 								((markasreviewed === 1 || markasreviewed === true)
              // 									? true
              // 									: isAssigned
              // 									? false
              // 									: true)
              // 								)
              // 							}
              // 							control={
              // 								loadingStates[questionId] ? (
              // 								<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10 }}>
              // 									<CircularProgress size={16} />
              // 								</div>
              // 								) : (
              // 								<BpCheckbox checked={markasreviewed === 1 || markasreviewed === true ? true : false} onChange={(e) => handleMarkAsReviewChange(question.index, e.target.checked ? 1 : 0, questionId)} />
              // 								)
              // 							}
              // 							label={markasreviewed === 1 || markasreviewed === true ? "Marked as Reviewed" : "Mark as Reviewed"}
              // 							labelPlacement="end"
              // 							/>
              // 						}

              // 						<Step key={i}>
              // 							<List style={{ maxHeight: "150px", overflow: "auto", padding: "5px", border: "1px dotted #ddd", borderRadius: "5px" }}>
              // 							{filteredComments?.filter((subcomment) => subcomment.comment?.trim() !== "").length > 0 ? (
              // 								filteredComments
              // 								.filter((subcomment) => subcomment.comment?.trim() !== "")
              // 								.map((subcomment, index) => {
              // 								const commentText = subcomment.comment;
              // 								return (
              // 									<ListItem key={index}>
              // 									<ListItemAvatar>
              // 										<Avatar>
              // 										<ThreePTwoToneIcon />
              // 										</Avatar>
              // 									</ListItemAvatar>
              // 									<ListItemText
              // 										primary={commentText}
              // 										secondary={
              // 										<Typography component="span" variant="body2" style={{ fontStyle: "italic" }}>
              // 											@ {subcomment?.reviewer_name || "N/A"}
              // 										</Typography>
              // 										}
              // 									/>
              // 									</ListItem>
              // 								);
              // 								})
              // 							) : (
              // 								<Typography variant="body2" style={{ padding: "10px", textAlign: "center", color: "#888" }}>
              // 								No comments yet
              // 								</Typography>
              // 							)}
              // 							</List>
              // 						</Step>
              // 						{
              // 							isAssigned && markasreviewed !== true &&
              // 							<Fab
              // 							disabled={myAssessments?.some(
              // 								(assessment) =>
              // 								currentAssessmentId === assessment?.assessment_id &&
              // 								assessment?.assessment_state === 'ReferBack'
              // 							)}
              // 							onClick={() => handleSubCommentModal(question.index, questionId)}
              // 							variant="extended" size="small" color="primary" sx={{ mt: 1 }}>
              // 							<AddIcon sx={{ mr: 1 }} />
              // 							Add Comment
              // 							</Fab>
              // 						}
              // 						{ (employeeType === "MASAD" ||  employeeType === "DEOP") && currentAssessment?.assessment_state === 'ReferBack' &&
              // 							<Fab
              // 							onClick={() => editQuestion(question.content, questionId)}
              // 							variant="extended" size="small" color="primary" sx={{ mt: 1 }}>
              // 								<EditIcon sx={{ mr: 1 }} />
              // 								Edit Question
              // 							</Fab>
              // 						}
              // 						</div>
              // 					</div>
              // 					);
              // 				})}
              // 				</div>
              // 			))}
              // 			</div>
              // 		))
              // 		) : (
              // 		<div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
              // 			Paper does not contain any questions.
              // 		</div>
              // 		)}
              // 		{employeeType !== "TEACH" &&
              // 		<div
              // 			style={{
              // 			display: 'flex',
              // 			alignItems: 'flex-start',
              // 			gap: '10px',
              // 			marginBottom: '20px',
              // 			padding: 5,
              // 			}}
              // 		>
              // 			<Step>
              // 			<h6>ProofReading Comments for Paper</h6>
              // 			<List
              // 				style={{
              // 				flex: 1,
              // 				maxHeight: '400px',
              // 				overflowY: 'auto',
              // 				padding: '10px',
              // 				border: '1px dotted #ddd',
              // 				borderRadius: '5px',
              // 				marginBottom: '10px',
              // 				}}
              // 			>
              // 				{operationComments?.filter((c) => c.comment?.trim() !== '').length > 0 ? (
              // 				operationComments
              // 				.filter((c) => c.comment?.trim() !== '')
              // 				.map((subcomment, index) => (
              // 					<ListItem key={index}>
              // 					<ListItemAvatar>
              // 						<Avatar>
              // 						<ThreePTwoToneIcon />
              // 						</Avatar>
              // 					</ListItemAvatar>
              // 					<ListItemText
              // 						primary={subcomment.comment}
              // 						secondary={
              // 						<Typography component="span" variant="body2" style={{ fontStyle: 'italic' }}>
              // 							@ {subcomment?.reviewer_name || 'N/A'}
              // 						</Typography>
              // 						}
              // 					/>
              // 					</ListItem>
              // 				))
              // 				) : (
              // 				<Typography
              // 					variant="body2"
              // 					style={{ padding: '10px', textAlign: 'center', color: '#888' }}
              // 				>
              // 					No proofreading comments for paper yet
              // 				</Typography>
              // 				)}
              // 			</List>
              // 			</Step>
              // 		</div>
              // 		}
              // 	</div>
              // </Typography>


              <Typography id="question-modal-description" sx={{ mt: 2 }}>
                <div ref={containerRef} style={{ overflowY: 'scroll', height: '500px' }}>
                  {questionContent?.length > 0 ? (
                    <>
                      {/* Render parts and sections structure */}
                      <AssessmentInfoCard details={assessmentDetails} />
                      {assessment_parts.sort((a, b) => a.display_order - b.display_order)?.map((part) => (
                        <div
                          key={`part-${part.part_id}`}
                          style={{ marginBottom: '30px', backgroundColor: '#fcf6ff', padding: '15px', borderRadius: '4px' }}
                        >
                          <Typography variant="h5" gutterBottom>
                            {part.part_title}
                          </Typography>

                          {part.allow_instruction && part.part_instruction?.trim() && (
                            <div style={{ marginBottom: '10px' }}>
                              <ul style={{ paddingLeft: '20px', margin: 0 }}>
                                {part.part_instruction
                                  .split(/\n|•|\*/g)
                                  .map(line => line.trim())
                                  .filter(line => line.length > 0)
                                  .map((line, idx) => (
                                    <li key={idx} style={{ marginBottom: '5px' }}>
                                      {line}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          )}

                          {/* Filter sections for this part */}
                          {assessment_sections
                            ?.filter(section => section.assessment_part_id === part.assessment_part_id)
                            .sort((a, b) => a.display_order - b.display_order)
                            .map(section => {
                              // Filter questions for this section
                              const sectionQuestions = questions
                                .filter(q => q.section_id === section.part_section_id)
                                .map((q) => {
                                  const index = questions.findIndex(qq => qq.question_id === q.question_id); // Find the global index
                                  return {
                                    ...q,
                                    content: questionContent[index],
                                    index: index
                                  };
                                });

                              if (sectionQuestions.length === 0) return null;

                              return (
                                <div
                                  key={`section-${section.part_section_id}`}
                                  style={{ marginBottom: '20px', backgroundColor: '#FFF6ED', padding: '15px', borderRadius: '4px' }}
                                >
                                  <Typography variant="h6" gutterBottom>
                                    {section.section_title}
                                  </Typography>

                                  {section.allow_instruction && section.section_instruction?.trim() && (
                                    <div style={{ marginBottom: '10px' }}>
                                      <ul style={{ paddingLeft: '20px', margin: 0 }}>
                                        {section.section_instruction
                                          .split(/\n|•|\*/g)
                                          .map(line => line.trim())
                                          .filter(line => line.length > 0)
                                          .map((line, idx) => (
                                            <li key={idx} style={{ marginBottom: '5px' }}>
                                              {line}
                                            </li>
                                          ))}
                                      </ul>
                                    </div>
                                  )}

                                  {/* Render questions for this section */}
                                  {sectionQuestions.map((question, i) => {
                                    const questionId = question.question_id;
                                    const markasreviewed = markAsReview?.find(
                                      (c) => c.question_id === questionId
                                    )?.mark_as_reviewed;

                                    const filteredComments = markAsReview?.filter(
                                      (c) => c.question_id === questionId
                                    );

                                    return (
                                      <div
                                        key={i}
                                        style={{
                                          display: 'flex',
                                          alignItems: 'flex-start',
                                          gap: '10px',
                                          marginBottom: '20px',
                                          padding: 5,
                                        }}
                                      >
                                        <div
                                          className={`question-item mb-5 ${'highlighted'}`}
                                          ref={questionRefs[question.index]}
                                          style={{ flex: '7' }}
                                        >
                                          {question.content}
                                        </div>

                                        <div style={{ flex: '3', position: 'relative' }}>
                                          <Backdrop
                                            sx={(theme) => ({
                                              color: '#fff',
                                              zIndex: theme.zIndex.drawer + 1,
                                              position: 'absolute',
                                              borderRadius: '4px',
                                            })}
                                            open={comment_loading}
                                          >
                                            <CircularProgress color="inherit" />
                                          </Backdrop>
                                          {(employeeType !== "DEOP" && employeeType !== "MASAD") &&
                                            <FormControlLabel
                                              value="end"
                                              disabled={
                                                myAssessments?.some(
                                                  (assessment) =>
                                                    currentAssessmentId === assessment?.assessment_id &&
                                                    assessment?.assessment_state === 'ReferBack'
                                                ) || (
                                                  employeeType !== "MASAD" &&
                                                  ((markasreviewed === 1 || markasreviewed === true)
                                                    ? true
                                                    : isAssigned
                                                      ? false
                                                      : true)
                                                )
                                              }
                                              control={
                                                loadingStates[questionId] ? (
                                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10 }}>
                                                    <CircularProgress size={16} />
                                                  </div>
                                                ) : (
                                                  <BpCheckbox checked={markasreviewed === 1 || markasreviewed === true ? true : false}
                                                    onChange={(e) => handleMarkAsReviewChange(question.index, e.target.checked ? 1 : 0, questionId)} />
                                                )
                                              }
                                              label={markasreviewed === 1 || markasreviewed === true ? "Marked as Reviewed" : "Mark as Reviewed"}
                                              labelPlacement="end"
                                            />
                                          }

                                          <Step key={i}>
                                            <List style={{ maxHeight: "150px", overflow: "auto", padding: "5px", border: "1px dotted #ddd", borderRadius: "5px" }}>
                                              {filteredComments?.filter((subcomment) => subcomment.comment?.trim() !== "").length > 0 ? (
                                                filteredComments
                                                  .filter((subcomment) => subcomment.comment?.trim() !== "")
                                                  .map((subcomment, index) => {
                                                    const commentText = subcomment.comment;
                                                    return (
                                                      <ListItem key={index}>
                                                        <ListItemAvatar>
                                                          <Avatar>
                                                            <ThreePTwoToneIcon />
                                                          </Avatar>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                          primary={commentText}
                                                          secondary={
                                                            <>
                                                              <Typography component="span" variant="body2" style={{ fontStyle: "italic" }}>
                                                                @ {subcomment?.reviewer_name || "N/A"}
                                                              </Typography>
                                                              <br />
                                                              <Typography component="span" variant="caption" style={{ color: "#666" }}>
                                                                {TimeZoneHandler.formattedTimeString(subcomment?.created_at)}

                                                              </Typography>
                                                            </>
                                                          }
                                                        />
                                                      </ListItem>
                                                    );
                                                  })
                                              ) : (
                                                <Typography variant="body2" style={{ padding: "10px", textAlign: "center", color: "#888" }}>
                                                  No comments yet
                                                </Typography>
                                              )}
                                            </List>
                                          </Step>
                                          {
                                            isAssigned && markasreviewed !== true &&
                                            <Fab
                                              disabled={myAssessments?.some(
                                                (assessment) =>
                                                  currentAssessmentId === assessment?.assessment_id &&
                                                  assessment?.assessment_state === 'ReferBack'
                                              )}
                                              onClick={() => handleSubCommentModal(question.index, questionId)}
                                              variant="extended" size="small" color="primary" sx={{ mt: 1 }}>
                                              <AddIcon sx={{ mr: 1 }} />
                                              Add Comment
                                            </Fab>
                                          }
                                          {(employeeType === "MASAD" || employeeType === "DEOP" || employeeType === "TEACH") && (currentAssessment?.assessment_state === assessmentStatusConstants.REFERBACK.name || currentAssessment?.assessment_state === assessmentStatusConstants.INREVIEW.name || currentAssessment?.assessment_state === assessmentStatusConstants.REVIEW.name) &&
                                            <Fab
                                              onClick={() => editQuestion(question.content, questionId)}
                                              variant="extended" size="small" color="primary" sx={{ mt: 1 }}>
                                              <EditIcon sx={{ mr: 1 }} />
                                              Edit Question
                                            </Fab>
                                          }
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              );
                            })}
                        </div>
                      ))}
                    </>
                  ) : (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                      Paper does not contain any questions.
                    </div>
                  )}
                  {employeeType !== "TEACH" &&
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '10px',
                        marginBottom: '20px',
                        padding: 5,
                      }}
                    >
                      <Backdrop
                        sx={(theme) => ({
                          color: '#fff',
                          zIndex: theme.zIndex.drawer + 1,
                          position: 'absolute',
                          borderRadius: '4px',
                        })}
                        open={operation_comment_loading}
                      >
                        <CircularProgress color="inherit" />
                      </Backdrop>
                      <Step>
                        <h6>ProofReading Comments for Paper</h6>
                        <List
                          style={{
                            flex: 1,
                            maxHeight: '400px',
                            overflowY: 'auto',
                            padding: '10px',
                            border: '1px dotted #ddd',
                            borderRadius: '5px',
                            marginBottom: '10px',
                          }}
                        >
                          {operationComments?.filter((c) => c.comment?.trim() !== '').length > 0 ? (
                            operationComments
                              .filter((c) => c.comment?.trim() !== '')
                              .map((subcomment, index) => (
                                <ListItem key={index}>
                                  <ListItemAvatar>
                                    <Avatar>
                                      <ThreePTwoToneIcon />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={subcomment.comment}
                                    secondary={
                                      <>
                                        <Typography component="span" variant="body2" style={{ fontStyle: "italic" }}>
                                          @ {subcomment?.reviewer_name || "N/A"}
                                        </Typography>
                                        <br />
                                        <Typography component="span" variant="caption" style={{ color: "#666" }}>
                                          {TimeZoneHandler.formattedTimeString(subcomment?.created_at)}

                                        </Typography>
                                      </>
                                    }
                                  />
                                </ListItem>
                              ))
                          ) : (
                            <Typography
                              variant="body2"
                              style={{ padding: '10px', textAlign: 'center', color: '#888' }}
                            >
                              No proofreading comments for paper yet
                            </Typography>
                          )}
                        </List>
                      </Step>
                    </div>
                  }
                </div>
              </Typography>

            )
          }
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
            {currentAssessmentStatusId === assessmentStatusConstants.REFERBACK.id && (employeeType === "DEOP" || employeeType === "MASAD") &&
              <Button
                variant="contained"
                color="info"
                onClick={handleSetForReview}
              >
                Set For Review
              </Button>
            }
            {currentAssessmentStatusId === assessmentStatusConstants.ReviewCompleted.id && employeeType === "DEOP" &&
              <Button
                variant="contained"
                color="info"
                onClick={() => handleSetForReviewByCompleted(assessmentStatusConstants.READYTOPUBLISH.name)}
              >
                Set Back to Review
              </Button>
            }
            {currentAssessmentStatusId === assessmentStatusConstants.ReviewCompleted.id && employeeType === "DEOP" &&
              <Button
                variant="contained"
                color="secondary"
                onClick={handleSetForPublishByCompleted}
              >
                Set Ready to Publish
              </Button>
            }
            {isAssigned ? (
              <>
                {/* <Button disabled={!isChanged} onClick={handleSaveComments} variant="contained" color="primary">
									Save Comments
								</Button> */}
                {(currentAssessmentStatusId === assessmentStatusConstants.REVIEW.id || currentAssessmentStatusId === assessmentStatusConstants.INREVIEW.id) &&
                  <Button
                    variant="contained"
                    color="info"
                    onClick={() => {
                      if (validateAllQuestionsReviewed()) {
                        setIsFinishReviewModalOpen(true);
                      } else {
                        setSnackbar({
                          open: true,
                          message: 'Please mark all questions as reviewed before finishing the review.',
                          severity: 'error',
                        });
                      }
                    }}
                    disabled={
                      !myAssessments?.some(
                        (assessment) =>
                          currentAssessmentId === assessment?.assessment_id &&
                          assessment?.assessment_state === 'InReview'

                      )
                      || mark_as_review_loading || comment_loading
                    }
                  >
                    Finish Review
                  </Button>
                }
                {(currentAssessmentStatusId === assessmentStatusConstants.PROOFREADING.id || currentAssessmentStatusId === assessmentStatusConstants.DATAENTRYVERIFICATION.id) && operationComplete === false &&
                  <Button
                    variant="contained"
                    color="info"
                    onClick={handleFinishOperation}
                  >
                    Finish {currentAssessmentStatusId === assessmentStatusConstants.PROOFREADING.id ? assessmentStatusConstants.PROOFREADING.name : assessmentStatusConstants.DATAENTRYVERIFICATION.name}
                  </Button>
                }
                {employeeType === "MASAD" ? (

                  <Tooltip
                    placement='top'
                    title={
                      myAssessments?.some(
                        (assessment) =>
                          currentAssessmentId === assessment?.assessment_id &&
                          assessment?.assessment_state !== assessmentStatusConstants.READYTOPUBLISH.name
                      )
                        ? "Review needs to be finish before finalizing"
                        :
                        currentAssessment?.assessment_state === assessmentStatusConstants.REFERBACK.name ?
                          "Reviewer move paper to refer back"
                          :
                          ""
                    }
                  >
                    <span>
                      {currentAssessmentStatusId === assessmentStatusConstants.READYTOPUBLISH.id &&
                        <>
                          <Button
                            variant="contained"
                            color="info"
                            onClick={() => handleSetForReviewByCompleted(assessmentStatusConstants.ReviewCompleted.name)}
                            sx={{ marginRight: '10px' }}
                            disabled={myAssessments?.some(
                              (assessment) =>
                                currentAssessmentId === assessment?.assessment_id &&
                                assessment?.assessment_state !== assessmentStatusConstants.READYTOPUBLISH.name
                            )}
                          >
                            Return Approval
                          </Button>
                          <Button
                            variant="contained"
                            color="error"
                            disabled={myAssessments?.some(
                              (assessment) =>
                                currentAssessmentId === assessment?.assessment_id &&
                                assessment?.assessment_state !== assessmentStatusConstants.READYTOPUBLISH.name

                            ) || mark_as_review_loading
                            }
                            onClick={() => {
                              if (validateAllQuestionsReviewed()) {
                                handleFinalizeReview();
                              } else {
                                setSnackbar({
                                  open: true,
                                  message: 'Please mark all questions as reviewed before finishing the review.',
                                  severity: 'error',
                                });
                              }
                            }}
                          >
                            Finalize Paper & Publish

                          </Button>
                        </>
                      }
                    </span>
                  </Tooltip>
                ) : null}
              </>
            ) : employeeType === "MASAD" ? (

              <Tooltip
                placement='top'
                title={
                  myAssessments?.some(
                    (assessment) =>
                      currentAssessmentId === assessment?.assessment_id &&
                      assessment?.assessment_state !== assessmentStatusConstants.READYTOPUBLISH.name
                  )
                    ? "Review needs to be finish before finalizing"
                    :
                    currentAssessment?.assessment_state === assessmentStatusConstants.REFERBACK.name ?
                      "Reviewer Comment need to resolved"
                      :
                      ""
                }
              >
                <span>
                  <Button
                    variant="contained"
                    color="info"
                    onClick={() => handleSetForReviewByCompleted(assessmentStatusConstants.ReviewCompleted.name)}
                    sx={{ marginRight: '10px' }}
                    disabled={myAssessments?.some(
                      (assessment) =>
                        currentAssessmentId === assessment?.assessment_id &&
                        assessment?.assessment_state !== assessmentStatusConstants.READYTOPUBLISH.name
                    )}
                  >
                    Return Approval
                  </Button>

                  <Button
                    variant="contained"
                    color="error"
                    disabled={myAssessments?.some(
                      (assessment) =>
                        currentAssessmentId === assessment?.assessment_id &&
                        assessment?.assessment_state !== assessmentStatusConstants.READYTOPUBLISH.name
                    )}
                    onClick={handleFinalizeReview}
                  >
                    Finalize Paper & Publish
                  </Button>
                </span>
              </Tooltip>
            ) : null}

            <Button
              onClick={async () => {
                if (isChanged) {
                  try {
                    const confirmClose = await sweetAlert(
                      "Are you sure?",
                      "You want to close before saving!",
                      "warning"
                    );
                    if (confirmClose === false) {
                      setIsModalOpen(false);
                      setIsAssigned(false)
                      // setIsChanged(false);
                      setOperationComments([]);
                      validator.hideMessages()
                      validator.purgeFields()
                    }
                  } catch (error) {
                    console.error("Error while confirming close:", error);
                  }
                } else {
                  setIsModalOpen(false);
                  setIsAssigned(false)
                  // setIsChanged(false);
                  setOperationComments([]);
                  validator.hideMessages()
                  validator.purgeFields()
                }
              }}
              variant="outlined"
              color="secondary"
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>

      <Dialog open={openAssessmentStatusDialog} onClose={() => setOpenAssessmentStatusDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Change Assessment Status</DialogTitle>

        <DialogContent>
          <FormControl fullWidth size="small">
            <InputLabel id="status-select-label">Select Status</InputLabel>
            <Select
              labelId="status-select-label"
              value={selectedAssessmentStatus}
              label="Select Status"
              onChange={(e) => setSelectedAssessmentStatus(e.target.value)}
            >
              {statusOptions.map((status) => (
                <MenuItem key={status.id} value={status.name}>
                  {status.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenAssessmentStatusDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleUpdateAssessmentStatus}
            disabled={add_review_loading}
          >
            {add_review_loading ? "Updating..." : "Update Status"}
          </Button>
        </DialogActions>
      </Dialog>

      <FinishReviewModal
        open={isFinishReviewModalOpen}
        onClose={() => {
          setIsFinishReviewModalOpen(false);
          setIsModalOpen(false);
          setIsAssigned(false);
          // setIsChanged(false);
          setIsFinishReviewModalOpen(false);
          setCurrentAssessmentId(null);
          setCurrentAssessmentStatusId(null);
          setOperationComplete(false);
          setCurrentAssessment(null);
        }}
        onFinish={handleFinishReview}
        options={filteredStatusOptions.filter(
          (status) =>
            status?.key === "ReferBack" || status?.key === "ReviewCompleted"
        )}
      />
      {selectedQuestion.isOpen &&
        <EditQuestionModal
          open={selectedQuestion.isOpen}
          setOpen={setSelectedQuestion}
          selectedQuestionId={selectedQuestionId}
          selectedQuestion={selectedQuestion}
          currentAssessmentId={currentAssessmentId}
        />
      }

    </AdminTemplate>

  )

}

export default AssessmentReview